<template>
  <div class="p-3 bg-white card border-radius-xl mt-3 me-3" data-animation="FadeIn" v-if="state.planoTreino">
    <div class="row">
      <div class="col-12 text-center">
        <div class="row">
          <div class="col-md-4 col-12">
            <div class="my-auto ms-auto">
              <button type="button" class="mb-0 btn btn-sm bg-gradient-success" @click="elaborarTreino()">
                {{ $t('config_semanas') }}
              </button>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <span class="h5">{{ $t('elaborador_titulo') }}</span>
          </div>
          <div class="col-md-4 col-12 text-end">
            <div v-if="state.trainingNumber !== ''">
              <span class="font-weight-bold">
                {{ $t('treino') }}
                <span class="text-danger">{{ state.trainingNumber }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- BOTÕES PESO E CARDIO -->
      <div class="col-12 text-center mt-3">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="btn-group w-100" role="group">
              <button type="button" class="btn btn-lg"
                :class="state.trainingType === 'peso' ? 'btn-primary' : 'btn-outline-primary'"
                @click="mudarTipoTreino('peso')">
                {{ $t('weightTraining') }}
              </button>
              <button type="button" class="btn btn-lg"
                :class="state.trainingType === 'cardio' ? 'btn-primary' : 'btn-outline-primary'"
                @click="mudarTipoTreino('cardio')">
                {{ $t('cardio') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center">
        <!-- <h6 class="mt-3">
					{{ state.planoTreino.students[0].name }} / {{ state.planoTreino.name }}
				</h6> -->
        <div class="text-sm my-3">
          <span class="font-weight-bold">
            {{ state.planoTreino.students[0].name }} / {{ state.planoTreino.name }}
          </span>
          <br />
          <!-- DADOS DO PLANO DE TREINO -->
          <span class="font-weight-bold text-danger"> {{ $t('trainingCycle') }}: </span>
          {{ state.planoTreino.training_cycle.name.split(' ')[1] }} -
          <span class="font-weight-bold text-danger">{{ $t('objetivo') }}: </span>
          {{ state.planoTreino.objective }} -
          <span class="font-weight-bold text-danger">{{ $t('tipo') }}:</span>
          {{ state.planoTreino.plan_group == 0 ? $t('individual') : $t('group') }} -
          <span class="font-weight-bold text-danger">{{ $t('inicio') }}:</span>
          {{ $filters.datePtbr(state.planoTreino.initial_date) }} -
          <span class="font-weight-bold text-danger">{{ $t('fim') }}:</span>
          {{ $filters.datePtbr(state.planoTreino.final_date) }} -
          <span class="font-weight-bold text-danger">{{ $t('num_dias') }}:</span>
          {{
            $filters.countDayAndWeek(
              state.planoTreino.initial_date,
              state.planoTreino.final_date,
              'D',
            )
          }}
          - <span class="font-weight-bold text-danger">{{ $t('semanas') }}:</span>
          {{ state.semanas.length }}
          <br />
          <!-- DADOS DE PERIODIZAÇÃO DA SEMANA SELECIONADA -->
          <div v-if="state.selectedWeekData">
            <span class="font-weight-bold text-danger">{{ $t('data') }}: </span>
            {{ $filters.datePtbr(state.selectedWeekData.initial_date) }} {{ $t('to') }}
            {{ $filters.datePtbr(state.selectedWeekData.final_date) }} |
            <span class="font-weight-bold text-danger">{{ $t('periodo') }}: </span>
            {{ state.selectedWeekData.period?.name }} |
            <span class="font-weight-bold text-danger">{{ $t('etapa') }}:</span>
            {{ state.selectedWeekData.step?.name }} |
            <span class="font-weight-bold text-danger">{{ $t('meso') }}:</span>
            {{ state.selectedWeekData.mesocycle?.name }} |
            <span class="font-weight-bold text-danger">{{ $t('micro') }}:</span>
            {{ state.selectedWeekData.microcycle?.name }} |
            <span class="font-weight-bold text-danger">{{ $t('metodo') }}:</span>
            {{ state.selectedWeekData.method?.name }} |
            <span class="font-weight-bold text-danger">{{ $t('percent_tec') }}:</span>
            {{ state.selectedWeekData.percent_technique }}% |
            <span class="font-weight-bold text-danger">{{ $t('percent_force') }}:</span>
            {{ state.selectedWeekData.percent_force }}% |
            <br />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- 1. SEMANAS DE TREINO -->
      <div class="col-12 col-md-auto">
        <div class="form-group">
          <label class="required">{{ $t('trainingWeeks') }}</label>
          <select class="form-control custom-select form-control-sm" style="width: auto; min-width: 320px;"
            name="tested_exercises" id="tested_exercises" @change="buscarTreinoSemana" v-model="state.selectedWeek">
            <option value="">{{ $t('selectTrainingWeek') }}</option>
            <option v-for="(item, index) in state.semanas" :key="index" :value="item.id">
              {{ $t('week') }} {{ index + 1 }} | {{ $filters.datePtbr(item.initial_date) }}
              {{ $t('to') }}
              {{ $filters.datePtbr(item.final_date) }}
            </option>
          </select>
        </div>
      </div>
      <!-- 2. EXERCÍCIOS TESTADOS -->
      <div class="col-12 form-group col-md-auto" v-if="state.trainingType === 'peso'">
        <label class="required">{{ $t('testedExercises') }}</label>
        <select class="form-control custom-select form-control-sm select-exercicios-testados"
          style="width: auto; min-width: 250px;" name="tested_exercises_top" id="tested_exercises_top"
          v-model="state.testedExerciseSelected" @change="adicionarExercicio('T')">
          <option value="">{{ $t('selectExercise') }}</option>
          <option value="0">{{ $t('addAll') }}</option>
          <option v-for="(item, index) in state.exerciciosTestados" :key="index" :value="item.id"
            :class="{ 'exercise-added': exercicioJaAdicionado(item.exercise.id) }">
            <span v-if="exercicioJaAdicionado(item.exercise.id)" class="icon-added">● </span>{{ item.exercise.name }}
          </option>
        </select>
      </div>
      <!-- 3. SELEÇÃO DE SEMANAS -->
      <div class="col-12 form-group col-md-auto" v-if="state.semanas.length > 0 && state.planoTreino.groups.length > 0"
        style="min-width: 400px;">
        <label for="">{{ $t('selectWeeks') }}</label>
        <select-box-dia-treino :ItemsProp="state.semanasSelect" :FieldProp="'name'"
          :GruposProp="state.planoTreino.groups" :PlaceholderTextProp="$t('select')"
          @salvarDias="adicionarGruposDias"></select-box-dia-treino>
      </div>
    </div>

    <!-- QUADRO DE TOTAIS - Separado em sua própria row -->
    <div class="row mt-3" v-if="state.daysOfWeek.length > 0 && (state.totals != null || state.totalsCardio != null)">
      <div class="col-12">
        <div class="d-flex justify-content-start gap-4 flex-wrap">
          <!-- TABELA DE TOTAIS - PESO -->
          <div v-if="state.totals != null">
            <h6 class="mb-2 text-primary fw-bold">
              <i class="fas fa-dumbbell me-1"></i> Totais - Peso
            </h6>
            <table class="table table-bordered totals-table mb-0">
              <thead class="table-light">
                <tr>
                  <th class="text-start" style="border-right: 2px solid #dee2e6;"></th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">{{ $t('series') }}</th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">{{ $t('repetitions') }}</th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">{{ $t('ton') }}</th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">{{ $t('pm') }}</th>
                  <th class="text-center">{{ $t('imr') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="fw-semibold text-start px-2" style="border-right: 2px solid #dee2e6;">{{ $t('total_semana') }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.week.series }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.week.repetitions }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.week.tonnage }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.week.middleWeight }}</td>
                  <td class="text-center px-2">{{ state.totals.week.imr }}</td>
                </tr>
                <tr>
                  <td class="fw-semibold text-start px-2" style="border-right: 2px solid #dee2e6;">{{ $t('total_plano') }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.plan.series }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.plan.repetitions }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.plan.tonnage }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.plan.middleWeight }}</td>
                  <td class="text-center px-2">{{ state.totals.plan.imr }}</td>
                </tr>
                <tr>
                  <td class="fw-semibold text-start px-2" style="border-right: 2px solid #dee2e6;">{{ $t('total_acumulado') }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.accumulated.series }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.accumulated.repetitions }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.accumulated.tonnage }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totals.accumulated.middleWeight }}</td>
                  <td class="text-center px-2">{{ state.totals.accumulated.imr }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- TABELA DE TOTAIS - CARDIO -->
          <div v-if="state.totalsCardio != null">
            <h6 class="mb-2 text-danger fw-bold">
              <i class="fas fa-heartbeat me-1"></i> Totais - Cardio
            </h6>
            <table class="table table-bordered totals-table totals-table-cardio mb-0">
              <thead class="table-light">
                <tr>
                  <th class="text-start" style="border-right: 2px solid #dee2e6;"></th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">Estágios</th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">Distância</th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">Tempo</th>
                  <th class="text-center" style="border-right: 2px solid #dee2e6;">Recuperação</th>
                  <th class="text-center">Média FCA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="fw-semibold text-start px-2" style="border-right: 2px solid #dee2e6;">{{ $t('total_semana') }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.week?.estagios || state.totalsCardio.estagios || 0 }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ formatarNumeroGrande(state.totalsCardio.week?.distancia || state.totalsCardio.distancia || 0) }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.week?.tempo || state.totalsCardio.tempo || '00:00' }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.week?.tempoRecuperacao || state.totalsCardio.tempoRecuperacao || '00:00' }}</td>
                  <td class="text-center px-2">{{ state.totalsCardio.week?.mediaFca || state.totalsCardio.mediaFca || 0 }}</td>
                </tr>
                <tr>
                  <td class="fw-semibold text-start px-2" style="border-right: 2px solid #dee2e6;">{{ $t('total_plano') }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.plan?.estagios || 0 }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ formatarNumeroGrande(state.totalsCardio.plan?.distancia || 0) }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.plan?.tempo || '00:00' }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.plan?.tempoRecuperacao || '00:00' }}</td>
                  <td class="text-center px-2">{{ state.totalsCardio.plan?.mediaFca || 0 }}</td>
                </tr>
                <tr>
                  <td class="fw-semibold text-start px-2" style="border-right: 2px solid #dee2e6;">{{ $t('total_acumulado') }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.accumulated?.estagios || 0 }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ formatarNumeroGrande(state.totalsCardio.accumulated?.distancia || 0) }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.accumulated?.tempo || '00:00' }}</td>
                  <td class="text-center px-2" style="border-right: 2px solid #dee2e6;">{{ state.totalsCardio.accumulated?.tempoRecuperacao || '00:00' }}</td>
                  <td class="text-center px-2">{{ state.totalsCardio.accumulated?.mediaFca || 0 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--    ABAS DE DIAS DA SEMANA-->
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs" id="myTab-elaborador-individual" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="elaborador-tab" data-bs-toggle="tab" data-bs-target="#elaborador"
              type="button" role="tab" aria-controls="elaborador" aria-selected="true"
              @click="state.selectedTab = 'elaborador'">
              Elaborador
              <br />
              <span style="font-size: 0.7em" class="text-white"> segredo </span>
            </button>
          </li>
          <li class="nav-item" role="presentation" v-for="(item, index) in state.daysOfWeek" :key="index"
            @click.passive="state.trainingNumber = item.training_number">
            <button class="nav-link" :id="item.day + '-tab'" data-bs-toggle="tab" :data-bs-target="'#' + item.day"
              type="button" role="tab" :aria-controls="item.day" aria-selected="true"
              @click="state.selectedTab = item.day">
              <span class="font-weight-bold">
                {{ $filters.nameDayPortuguese(item.day) }}
              </span>
              <span class="small"> - {{ item.base_group_name }} </span>
              <!-- Indicador de cardio -->
              <span v-if="hasCardioExercises(item)" class="badge bg-primary ms-1" style="font-size: 0.6rem">
                CARDIO
              </span>
              <i class="fas fa-trash text-secondary ms-2" style="font-size: 0.9rem"
                @click="removerDiaSemana($filters.nameDayPortuguese(item.day), item, index)"></i>
              <br />
              <span style="font-size: 0.7em">
                {{ item.day_date.split('-').reverse().join('/') }}
              </span>
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade active show" id="elaborador" role="tabpanel" aria-labelledby="elaborador-tab">
            <!-- EXERCICIOS TESTADOS -->
            <div class="row mt-3">
              <!-- CAMPOS PARA TREINO DE PESO -->
              <div v-if="state.trainingType === 'peso'" class="row w-100">
                <div class="col-12 form-group col-md-auto">
                  <label for="">{{ $t('selectGroupTraining') }}</label>
                  <select class="form-control form-control-sm custom-select" style="width: auto; min-width: 200px;"
                    name="student-manager" required id="select-student-manager" @change="buscaExercicioGrupoTreino"
                    v-model="state.trainingPlanGroupId">
                    <option value="">{{ $t('selectGroupTraining') }}</option>
                    <option v-for="(item, index) in state.planoTreino.groups" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>

                  <!-- NOVO: botões apagar treinos do grupo -->
                  <div class="mt-2 d-flex gap-2" v-if="Number(state.trainingPlanGroupId) > 0 && !state.grupoSoCardio">
                    <button type="button" class="btn btn-sm btn-danger" @click="apagarTodosDoGrupo">
                      Apagar todos
                    </button>
                    <button type="button" class="btn btn-sm btn-warning" @click="apagarSelecionados"
                      :disabled="!temExerciciosSelecionados">
                      Apagar selecionados
                    </button>
                  </div>

                  <!-- AVISO: Grupo só tem exercícios de cardio -->
                  <div v-if="state.grupoSoCardio" class="mt-3 alert alert-warning d-flex align-items-center" role="alert">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    <div>
                      <strong>Este é um grupo de Cardio!</strong><br>
                      Para visualizar e editar os exercícios deste grupo, clique no botão <strong>CARDIO</strong> acima.
                    </div>
                  </div>
                </div>
              </div>

              <!-- CAMPOS PARA TREINO DE CARDIO -->
              <div v-if="state.trainingType === 'cardio' && state.selectedTab === 'elaborador'" class="row w-100">
                <!-- CAMPOS DE SELEÇÃO -->
                <div class="col-12 mb-3">
                  <div class="row">
                    <div class="col-12 form-group col-md-3">
                      <label for="">{{ $t('selectGroupTraining') }}</label>
                      <select class="form-control form-control-sm custom-select" style="width: auto; min-width: 200px;"
                        name="student-manager" required id="select-student-manager-cardio"
                        @change="buscaExercicioGrupoTreino" v-model="state.trainingPlanGroupId">
                        <option value="">{{ $t('selectGroupTraining') }}</option>
                        <option v-for="(item, index) in state.planoTreino.groups" :key="index" :value="item.id">
                          {{ item.name }}
                        </option>
                      </select>

                      <!-- NOVO: botões apagar treinos do grupo (cardio) -->
                      <div class="mt-2 d-flex gap-2" v-if="Number(state.trainingPlanGroupId) > 0">
                        <button type="button" class="btn btn-sm btn-danger" @click="apagarTodosDoGrupo"
                          :disabled="!state.trainingPlanGroupId">
                          Apagar todos
                        </button>
                        <button type="button" class="btn btn-sm btn-warning" @click="apagarSelecionados"
                          :disabled="!state.trainingPlanGroupId || !temExerciciosSelecionados">
                          Apagar selecionados
                        </button>
                      </div>
                    </div>
                    <div class="col-12 form-group col-md-3">
                      <label>{{ $t('method') }}</label>
                      <select class="form-control custom-select form-control-sm" name="metodos"
                        v-model="state.cardio.cardio_method_id">
                        <option value="0">{{ $t('selectMethod') }}</option>
                        <option v-for="(metodo, index) in state.metodos" :key="index" :value="metodo.id">
                          {{ metodo.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12 form-group col-md-3">
                      <label>{{ $t('modality') }}</label>
                      <select class="form-control custom-select form-control-sm" name="modalidades"
                        id="select-modalidades-cardio" v-model="state.cardio.cardio_modality_id"
                        @change="buscarGrupoPorModalidadeCardio">
                        <option value="0">{{ $t('selectModality') }}</option>
                        <option v-for="(modalidade, index) in state.modalidades" :key="index" :value="modalidade.id">
                          {{ modalidade.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12 form-group col-md-3">
                      <label>{{ $t('group') }}</label>
                      <select class="form-control custom-select form-control-sm" name="grupos-cardio"
                        id="select-grupos-cardio" v-model="state.cardio.cardio_grupo_id"
                        @change="buscarExercicioPorGrupoCardio" :disabled="state.cardio.cardio_modality_id === 0">
                        <option value="0">
                          {{
                            state.cardio.cardio_modality_id === 0
                              ? 'Selecione a modalidade primeiro'
                              : $t('selectGroupTraining')
                          }}
                        </option>
                        <option v-for="(grupo, index) in state.gruposCardio" :key="index" :value="grupo.id">
                          {{ grupo.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12 form-group col-md-3">
                      <label>{{ $t('exerciseName') }}</label>
                      <select class="form-control custom-select form-control-sm" name="exercicios-cardio"
                        id="select-exercicios-cardio" v-model="state.cardio.cardio_exercise_id"
                        :disabled="state.cardio.cardio_grupo_id === 0">
                        <option value="0">
                          {{
                            state.cardio.cardio_grupo_id === 0
                              ? 'Selecione o grupo primeiro'
                              : $t('selectExercise')
                          }}
                        </option>
                        <option v-for="(exercicio, index) in state.exercicios" :key="index" :value="exercicio.id">
                          {{ exercicio.name }}
                        </option>
                      </select>
                    </div>
                    <!-- MARCAR SEMANAS E DIAS PARA CARDIO -->
                    <!-- <div class="col-12 form-group col-md-3">
                      <div class="form-group">
                        <label>% Vo2max</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="% Vo2max"
                          v-model="state.cardio.vo2_percent"
                        />
                      </div>
                    </div>
                    <div class="col-12 form-group col-md-3">
                      <div class="form-group">
                        <label>% FCM</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="% FCM"
                          v-model="state.cardio.fcm_percent"
                        />
                      </div>
                    </div> -->
                  </div>
                </div>

                <!-- TÍTULO DO TREINAMENTO -->
                <div class="col-12 mb-3">
                  <h5 class="text-center">{{ getTituloTreinamentoCardio() }}</h5>
                </div>

                <!-- TABELA DINÂMICA BASEADA NO MÉTODO -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th class="bg-light">Estágio</th>
                          <th class="bg-light">Distancia (Metros)</th>
                          <th class="bg-light">{{ getColunaTempo() }}</th>
                          <th class="bg-light" v-if="isMetodoIntervalado()">
                            T. Recuperação (Min/Seg)
                          </th>
                          <th class="bg-light" v-if="isMetodoContinuo()">Pace (min/km)</th>
                          <th class="bg-light" v-if="isMetodoContinuo()">VO2/t</th>
                          <th class="bg-light" v-if="isMetodoContinuo()">FCtr</th>
                          <th class="bg-light" v-if="isMetodoIntervalado()">Carga</th>
                          <th class="bg-light" v-if="isMetodoIntervalado()">FCA</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(intervalo, index) in state.cardio.intervalos" :key="index">
                          <td>
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.estagio"
                              placeholder="Estágio" v-maska="'##'" />
                          </td>
                          <td>
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.distancia"
                              placeholder="Distância" v-maska="'####'" />
                          </td>
                          <td>
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.tempo"
                              :placeholder="getPlaceholderTempo()" v-maska="getMascaraTempo()" />
                          </td>
                          <td v-if="isMetodoIntervalado()">
                            <input type="text" class="form-control form-control-sm"
                              v-model="intervalo.tempo_recuperacao" placeholder="00:00" v-maska="'##:##'" />
                          </td>
                          <td v-if="isMetodoContinuo()">
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.pace"
                              placeholder="Pace" v-maska="'####.##'" />
                          </td>
                          <td v-if="isMetodoContinuo()">
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.vo2_t"
                              placeholder="VO2/t" v-maska="'###.##'" />
                          </td>
                          <td v-if="isMetodoContinuo()">
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.fctr"
                              placeholder="FCtr" v-maska="'###'" />
                          </td>
                          <td v-if="isMetodoIntervalado()">
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.carga"
                              placeholder="Carga" v-maska="'###'" />
                          </td>
                          <td v-if="isMetodoIntervalado()">
                            <input type="text" class="form-control form-control-sm" v-model="intervalo.fca"
                              placeholder="FCA" v-maska="'###'" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- BOTÕES + E - (ACIMA DO SOMATÓRIO) -->
                  <div class="row mt-3">
                    <!-- BOTÃO ADICIONAR LINHA (ESQUERDA) -->
                    <div class="col-auto">
                      <button type="button" class="btn btn-outline-info btn-sm" @click="adicionarIntervalo"
                        title="Adicionar Linha">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>

                    <!-- BOTÃO REMOVER LINHA (DIREITA) -->
                    <div class="col-auto ms-auto">
                      <button type="button" class="btn btn-outline-danger btn-sm" @click="removerUltimoIntervalo"
                        title="Remover Linha">
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>

                  <!-- BOTÃO TOTAL (ACIMA DO SOMATÓRIO) -->
                  <div class="row mt-3">
                    <div class="col text-center">
                      <button type="button" class="btn btn-outline-info btn-lg" @click="calcularTotais">
                        Total
                      </button>
                    </div>
                  </div>

                  <!-- RESUMO SOMATÓRIO E MÉDIA (TUDO EM UMA LINHA HORIZONTAL) -->
                  <div class="row mt-3" v-if="state.cardio.resumo">
                    <div class="col-12">
                      <div class="row justify-content-center">
                        <div class="col-md-12">
                          <div class="row justify-content-center">
                            <!-- TODAS AS CAIXAS EM UMA LINHA -->
                            <div class="col-auto text-center me-4">
                              <div class="bg-light rounded p-2" style="min-width: 150px">
                                {{ state.cardio.resumo.somaEstagio || 0 }}
                              </div>
                            </div>
                            <div class="col-auto text-center me-4">
                              <div class="bg-light rounded p-2" style="min-width: 150px">
                                {{ state.cardio.resumo.somaDistancia || 0 }}
                              </div>
                            </div>
                            <div class="col-auto text-center me-4">
                              <div class="bg-light rounded p-2" style="min-width: 150px">
                                {{
                                  formatarSegundosParaTempo(
                                    state.cardio.resumo.somaTempo || 0,
                                    isMetodoIntervalado(),
                                  )
                                }}
                              </div>
                            </div>
                            <div class="col-auto text-center me-4">
                              <div class="bg-light rounded p-2" style="min-width: 150px">
                                {{
                                  isMetodoIntervalado()
                                    ? formatarSegundosParaTempo(
                                      state.cardio.resumo.somaRecuperacao || 0,
                                      true,
                                    )
                                    : state.cardio.resumo.mediaPace || 0
                                }}
                              </div>
                            </div>
                            <div class="col-auto text-center me-4">
                              <div class="bg-light rounded p-2" style="min-width: 150px">
                                {{
                                  isMetodoContinuo()
                                    ? state.cardio.resumo.mediaPace || 0
                                    : state.cardio.resumo.mediaCarga || 0
                                }}
                              </div>
                            </div>
                            <div class="col-auto text-center me-4">
                              <div class="bg-light rounded p-2" style="min-width: 150px">
                                {{
                                  isMetodoContinuo()
                                    ? state.cardio.resumo.mediaVo2t || 0
                                    : state.cardio.resumo.mediaFca || 0
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- TODOS OS EXERCÍCIOS DE CARDIO DO GRUPO -->
                  <div v-if="state.cardio.exercicios && state.cardio.exercicios.length > 0" class="row mt-4">
                    <div class="col-12">
                      <h6 class="mb-3">Exercícios de Cardio Existentes:</h6>

                      <!-- Cada exercício como uma cópia do formulário principal -->
                      <div v-for="(exercicio, index) in state.cardio.exercicios" :key="exercicio.id" class="card mb-4">
                        <div class="card-header d-flex justify-content-between align-items-center">
                          <h6 class="mb-0">
                            {{ getNomeMetodo(exercicio.method_id) }} - Exercício {{ index + 1 }}
                          </h6>
                          <div>
                            <button type="button" class="btn btn-sm btn-info me-2"
                              @click="carregarExercicioCardio(exercicio)">
                              Editar
                            </button>
                            <button type="button" class="btn btn-sm btn-danger"
                              @click="deletarExercicioCardio(exercicio.id)">
                              Deletar
                            </button>
                          </div>
                        </div>
                        <div class="card-body">
                          <!-- CAMPOS DO EXERCÍCIO - COPIADOS DO FORMULÁRIO PRINCIPAL -->
                          <div class="col-12 form-group col-md-3">
                            <div class="form-group">
                              <label>{{ $t('selectGroupTraining') }}</label>
                              <select class="form-control" v-model="exercicio.group_id"
                                @change="buscarExercicioPorGrupoCardio(exercicio)">
                                <option value="">{{ $t('selectGroupTraining') }}</option>
                                <option v-for="grupo in state.grupos" :key="grupo.id" :value="grupo.id">
                                  {{ grupo.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 form-group col-md-3">
                              <div class="form-group">
                                <label>Modalidade</label>
                                <select class="form-control" v-model="exercicio.modality_id"
                                  @change="buscarGrupoPorModalidadeCardio(exercicio)">
                                  <option value="">{{ $t('selectModalityPlaceholder') }}</option>
                                  <option v-for="modalidade in state.modalidades" :key="modalidade.id"
                                    :value="modalidade.id">
                                    {{ modalidade.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-12 form-group col-md-3">
                              <div class="form-group">
                                <label>Método</label>
                                <select class="form-control" v-model="exercicio.method_id"
                                  @change="buscarGrupoPorModalidadeCardio(exercicio)">
                                  <option value="">{{ $t('selectMethodPlaceholder') }}</option>
                                  <option v-for="metodo in state.metodos" :key="metodo.id" :value="metodo.id">
                                    {{ metodo.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-12 form-group col-md-3">
                              <div class="form-group">
                                <label>% Vo2max</label>
                                <input type="text" class="form-control" v-model="exercicio.vo2_percent"
                                  placeholder="% Vo2max" />
                              </div>
                            </div>
                            <div class="col-12 form-group col-md-3">
                              <div class="form-group">
                                <label>% FCM</label>
                                <input type="text" class="form-control" v-model="exercicio.fcm_percent"
                                  placeholder="% FCM" />
                              </div>
                            </div>
                          </div>

                          <!-- TABELA DE INTERVALOS - COPIADA DO FORMULÁRIO PRINCIPAL -->
                          <div class="row mt-4">
                            <div class="col-12">
                              <h5 class="text-center">
                                {{ getTituloTreinamentoCardio(exercicio.method_id) }}
                              </h5>
                              <div class="table-responsive">
                                <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Estágio</th>
                                      <th>Distancia (Metros)</th>
                                      <th>{{ getColunaTempo(exercicio.method_id) }}</th>
                                      <th v-if="isMetodoIntervalado(exercicio.method_id)">
                                        T. Recuperação (Min/Seg)
                                      </th>
                                      <th v-if="isMetodoIntervalado(exercicio.method_id)">Carga</th>
                                      <th v-if="isMetodoIntervalado(exercicio.method_id)">FCA</th>
                                      <th v-if="isMetodoContinuo(exercicio.method_id)">
                                        Pace (Min/Km)
                                      </th>
                                      <th v-if="isMetodoContinuo(exercicio.method_id)">VO2/T</th>
                                      <th v-if="isMetodoContinuo(exercicio.method_id)">FCtr</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(intervalo, index) in exercicio.intervalos" :key="index">
                                      <td>
                                        <input type="text" class="form-control form-control-sm"
                                          v-model="intervalo.estagio" placeholder="Estágio" />
                                      </td>
                                      <td>
                                        <input type="text" class="form-control form-control-sm"
                                          v-model="intervalo.distancia" placeholder="Distancia" v-maska="'####'" />
                                      </td>
                                      <td>
                                        <input type="text" class="form-control form-control-sm"
                                          v-model="intervalo.tempo"
                                          :placeholder="getPlaceholderTempo(exercicio.method_id)"
                                          v-maska="getMascaraTempo(exercicio.method_id)" />
                                      </td>
                                      <td v-if="isMetodoIntervalado(exercicio.method_id)">
                                        <input type="text" class="form-control form-control-sm"
                                          v-model="intervalo.tempo_recuperacao" placeholder="00:00" v-maska="'##:##'" />
                                      </td>
                                      <td v-if="isMetodoIntervalado(exercicio.method_id)">
                                        <input type="text" class="form-control form-control-sm"
                                          v-model="intervalo.carga" placeholder="Carga" v-maska="'###'" />
                                      </td>
                                      <td v-if="isMetodoIntervalado(exercicio.method_id)">
                                        <input type="text" class="form-control form-control-sm" v-model="intervalo.fca"
                                          placeholder="FCA" v-maska="'###'" />
                                      </td>
                                      <td v-if="isMetodoContinuo(exercicio.method_id)">
                                        <input type="text" class="form-control form-control-sm" v-model="intervalo.pace"
                                          placeholder="Pace" v-maska="'####.##'" />
                                      </td>
                                      <td v-if="isMetodoContinuo(exercicio.method_id)">
                                        <input type="text" class="form-control form-control-sm"
                                          v-model="intervalo.vo2_t" placeholder="VO2/t" v-maska="'###.##'" />
                                      </td>
                                      <td v-if="isMetodoContinuo(exercicio.method_id)">
                                        <input type="text" class="form-control form-control-sm" v-model="intervalo.fctr"
                                          placeholder="FCtr" v-maska="'###'" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="text-center mt-3">
                                <button type="button" class="btn bg-gradient-info btn-sm"
                                  @click="adicionarIntervaloParaExercicio(exercicio)">
                                  + Adicionar {{ getTextoBotao(exercicio.method_id) }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- BOTÕES SALVAR E LIMPAR PARA CARDIO -->
                  <div class="row justify-content-end mt-4">
                    <div class="col-auto">
                      <button type="button" class="btn bg-gradient-success btn-sm" @click="adicionarExerciciosGrupo">
                        {{ $t('save') }}
                      </button>
                      <button type="button" class="ms-3 btn bg-gradient-primary btn-sm" @click="limparExercicios">
                        {{ $t('clear') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <TabelaExercicios v-if="
              (state.exerciciosTestados.length > 0 || state.treinoElaborado.length > 0 || temExerciciosCopiados) &&
              state.trainingType === 'peso'
            " :exerciciosProp="state.treinoElaborado" :exerciciosTestadosProp="state.exerciciosTestados"
              @update:exerciciosProp="atualizarExerciciosGrupo">
            </TabelaExercicios>

            <div class="row" v-show="state.treinoElaborado.length > 0 && state.trainingType === 'peso'">
              <div class="col-12 col-md-6">
                <div class="form-group d-flex">
                  <label for="" class="me-3">{{ $t('observacoes') }}: </label>
                  <textarea rows="3" class="form-control form-control-sm" style="resize: none"
                    v-model="state.observation" />
                </div>
              </div>
            </div>
            <div class="row" v-if="state.trainingType === 'peso'">
              <div class="col-12 text-end">
                <button type="button" id="btnSalvarExerciciosGrupo" :disabled="state.btnSalvarExerciciosDisabled"
                  class="btn bg-gradient-success btn-sm" @click="adicionarExerciciosGrupo">
                  {{ $t('save') }}
                </button>
                <button type="button" class="ms-3 btn bg-gradient-primary btn-sm" @click="limparExercicios">
                  {{ $t('clear') }}
                </button>
              </div>
            </div>
          </div>
          <!--          LISTAGEM DAS ABAS DE DIAS DA SEMANA SELECIONADA-->
          <div class="tab-pane fade" v-for="(item, index) in state.daysOfWeek" :key="index" :id="item.day"
            role="tabpanel" :aria-labelledby="item.day + '-tab'">
            <tabela-exercicios-elaborados :exerciciosTestadosProp="state.exerciciosTestados"
              :exerciciosProp="item.exercises" :isEditMode="state.selectedTab === 'elaborador'"
              @refresh-week="buscarTreinoSemana"
              @update:exerciciosProp="(novosExercicios) => atualizarExerciciosDia(item.day, novosExercicios)"></tabela-exercicios-elaborados>
          </div>
        </div>
      </div>
    </div>

    <!-- TODAS MODALIDADES, GRUPOS E EXERCICIOS -->
    <div class="row" v-if="state.trainingType === 'peso'">
      <div class="col-12 col-md-4 mt-sm-0">
        <label>{{ $t('modality') }}</label>
        <select class="form-control custom-select form-control-sm" name="modalidades" id="select-modalidades"
          @change="buscarGrupoPorModalidade" v-model="state.modalidadeSelecionadaId">
          <option value="0">{{ $t('selectModality') }}</option>
          <option v-for="(modalidade, index) in state.modalidades" :key="index" :value="modalidade.id">
            {{ modalidade.name }}
          </option>
        </select>
      </div>
      <div class="col-12 col-md-4 mt-sm-0">
        <label>{{ $t('group') }}</label>
        <select class="form-control custom-select form-control-sm" name="grupos" @change="buscarExercicioPorGrupo"
          v-model="state.grupoSelecionadoId">
          <option value="0">{{ $t('selectGroupTraining') }}</option>
          <option v-for="(item, index) in state.grupos" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="col-12 col-md-4 mt-sm-0">
        <label>{{ $t('exerciseName') }}</label>
        <select class="form-control custom-select form-control-sm" name="grupos" v-model="state.exercicioSelecionadoId"
          @change="adicionarExercicio()">
          <option value="0">{{ $t('selectGroupTraining') }}</option>
          <option v-for="(item, index) in state.exercicios" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row" v-if="state.trainingType === 'peso'">
      <div class="col-12 text-center">
        <router-link :to="{ name: 'PlanoTreinoSemanas' }" class="text-danger text-sm">
          [ {{ $t('back') }} - {{ $t('trainingWeeksListing') }} ]
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import kpiRepository from '../../../../services/api/kpiRepository'
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'
import modalidadeRepository from '../../../../services/api/modalidadeRepository'
import grupoRepository from '../../../../services/api/grupoRepository'
import exercicioRepository from '../../../../services/api/exercicioRepository'
import testesCargaRepository from '../../../../services/api/testesCargaRepository'
import metodoRepository from '../../../../services/api/metodoRepository'
import { inject, onMounted, reactive, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import TabelaExercicios from './TabelaExercicios.vue'
import SemanaElaborada from './SemanaElaborada.vue'
import TabelaExerciciosElaborados from './TabelaExerciciosElaborados.vue'
import SelectBoxDiaTreino from './../../../../components/SelectBoxDiaTreino.vue'
import { Money3Component } from 'v-money3'

export default {
  components: {
    TabelaExercicios,
    SemanaElaborada,
    TabelaExerciciosElaborados,
    SelectBoxDiaTreino,
    money3: Money3Component,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()
    onMounted(() => {
      //store.commit('SET_COPY_EXERCISES', [])
      store.commit('SET_SPLASH_SCREEN', false)

      state.planoTreinoId = store.getters.TrainingPlanManager
      if (state.planoTreinoId) {
        buscarModalidade()
        buscarMetodos()
        buscarDadosPlanoTreino()
        buscarPlanoDetreinoSemanas()
      } else {
        // Mostrar alerta se não tiver aluno e plano selecionados
        swal({
          icon: 'warning',
          title: 'SELECIONE UM ALUNO E UM PLANO DE TREINO PRIMEIRO',
          text: 'Por favor, selecione um aluno e um plano de treino no menu superior antes de acessar o elaborador de treino.',
        })
      }

      // Se o tipo de treino for cardio, não carregar exercícios automaticamente
      // Eles serão carregados quando a modalidade for selecionada
    })

    const state = reactive({
      observation: '',
      selectedTab: 'elaborador',
      trainingPlanGroupId: '',
      totals: null,
      totalsCardio: null, // ✅ Totalizadores de cardio
      selectedWeek: '',
      semanasSelecionadas: null,
      diasDaSemanaSelecionadas: [],
      planoTreinoId: 0,
      planoTreino: null,
      btnSalvarExerciciosDisabled: false,
      trainingNumber: '',
      grupoSelecionadoId: '0',
      modalidadeSelecionadaId: '0',
      exercicioSelecionadoId: '0',
      modalidades: [],
      grupos: [],
      gruposCardio: [],
      exercicios: [],
      exerciciosTestados: [],
      testedExerciseSelected: '',
      testedExerciseSelectedTab: '', // ✅ NOVO: para usar nas abas
      treinoElaborado: [],
      semanas: [],
      daysOfWeek: [],
      weekTraining: [],
      semanasSelecionadasCheckbox: [],
      semanasSelect: [],
      selectedWeekData: null,
      trainingType: 'peso', // Tipo de treino selecionado (peso ou cardio)
      grupoSoCardio: false, // ✅ Indica se o grupo selecionado só tem exercícios de cardio
      metodos: [], // Métodos para cardio
      existingCardioExerciseId: null, // ID do exercício de cardio existente (para update)
      cardio: {
        cardio_method_id: 0,
        cardio_modality_id: 0,
        cardio_grupo_id: 0,
        cardio_exercise_id: 0,
        vo2_max: '',
        fcm: '',
        vo2_percent: '',
        fcm_percent: '',
        intervalos: [
          {
            estagio: '',
            tempo: '',
            distancia: '',
            // Campos para método intervalado
            tempo_recuperacao: '',
            carga: '',
            fca: '',
            // Campos para método contínuo
            pace: '',
            vo2_t: '',
            fctr: '',
          },
        ],
        resumo: null, // Para armazenar os totais e médias
      },
      config: {
        masked: false,
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 3,
        disableNegative: false,
        disabled: false,
        min: 0,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: true,
        focusOnRight: false,
      },
    })

    const buscarTreinoSemana = async () => {
      state.trainingNumber = ''
      state.selectedWeekData = state.semanas.find((x) => x.id == state.selectedWeek)
      router.push({ query: { week: state.selectedWeek } })
      //console.log(state.selectedWeekData)
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await planosTreinoRepository.PlanoTreinoElaboradoBySemanaIdGet(
          state.selectedWeek,
        )
        if (response.data.success) {
          state.weekTraining = []
          state.weekTraining = response.data.data
          state.daysOfWeek = []
          if (!response.data.data) {
            swal({
              icon: 'info',
              text: 'Semana não elaborada!',
            })
            return
          }
          for (const [key, value] of Object.entries(response.data.data)) {
            console.log('Processando dia:', value['day_name'], 'Exercícios:', value['exercises'])
            let exercises = value['exercises'].map((exercise) => {
              //let item = state.testedExercises.find(x => x.exercise_id == exercise.exercise_id)
              let item = state.exerciciosTestados?.find((x) => x.exercise_id == exercise.exercise_id)
              exercise['max_load_test'] = item ? item.max_load_test : 0

              // Verificar se é exercício de cardio
              console.log('Verificando exercício:', exercise.exercise_id, 'Cardio fields:', {
                cardio_modality_id: exercise.cardio_modality_id,
                cardio_method_id: exercise.cardio_method_id,
                cardio_details: exercise.cardio_details,
                has_series: exercise.series && exercise.series.length > 0,
              })

              // Verificação mais específica para exercícios de cardio
              const isCardio =
                exercise.cardio_modality_id ||
                exercise.cardio_method_id ||
                (exercise.cardio_details && exercise.cardio_details.length > 0)

              if (isCardio) {
                // É exercício de cardio
                exercise['is_cardio'] = true
                console.log(
                  'Exercício identificado como CARDIO:',
                  exercise.exercise_id,
                  exercise.exercise?.name,
                )

                // Garantir que não tenha series (propriedade de peso)
                if (exercise.series) {
                  console.log('Removendo series de exercício de cardio:', exercise.exercise_id)
                  delete exercise.series
                }

                if (!exercise.cardio_details || exercise.cardio_details.length == 0) {
                  exercise.cardio_details = [
                    {
                      stage: '',
                      time: '',
                      distance: '',
                      recovery_time: '',
                      load: '',
                      fca: '',
                      pace: '',
                      vo2_per_time: '',
                      fctr: '',
                    },
                  ]
                } else {
                  // Garantir que os campos estejam mapeados corretamente
                  exercise.cardio_details = exercise.cardio_details.map((detail) => ({
                    stage: detail.stage || '',
                    time: converterTempoParaInterface(detail.time, true),
                    distance: detail.distance || '',
                    recovery_time: converterTempoParaInterface(detail.recovery_time, true),
                    load: detail.load || '',
                    fca: detail.fca || '',
                    pace: detail.pace || '',
                    vo2_per_time: detail.vo2_per_time || '',
                    fctr: detail.fctr || '',
                  }))
                }
              } else {
                // É exercício de peso
                exercise['is_cardio'] = false
                console.log(
                  'Exercício identificado como PESO:',
                  exercise.exercise_id,
                  exercise.exercise?.name,
                )

                // Garantir que não tenha cardio_details (propriedade de cardio)
                if (exercise.cardio_details) {
                  console.log(
                    'Removendo cardio_details de exercício de peso:',
                    exercise.exercise_id,
                  )
                  delete exercise.cardio_details
                }

                if (!exercise.series || exercise.series.length == 0) {
                  exercise.series = [
                    {
                      repetitions: '',
                      load: '',
                      perc_load: '',
                      series: '',
                    },
                  ]
                }
              }
              return exercise
            })
            state.daysOfWeek.push({
              day: value['day_name'],
              day_date: value['day_date'],
              training_number: value['training_number'],
              base_group_name: value['base_group_name'],
              exercises: exercises,
            })
          }

          // Buscar exercícios de cardio para todos os grupos
          console.log('Buscando exercícios de cardio para todos os grupos...')
          let cardioExercises = []
          if (
            state.planoTreino &&
            state.planoTreino.groups &&
            state.planoTreino.groups.length > 0
          ) {
            for (let grupo of state.planoTreino.groups) {
              try {
                console.log('Buscando cardio para grupo:', grupo.id)
                let cardioResponse = await planosTreinoRepository.ExerciciosCardioPorGrupoIdGet(
                  grupo.id,
                )
                if (cardioResponse.data.success && cardioResponse.data.data.length > 0) {
                  console.log(
                    'Cardio encontrado para grupo',
                    grupo.id,
                    ':',
                    cardioResponse.data.data.length,
                    'exercícios',
                  )
                  cardioExercises.push(...cardioResponse.data.data)
                }
              } catch (cardioError) {
                console.error('Erro ao buscar cardio para grupo', grupo.id, ':', cardioError)
              }
            }
          }

          // Adicionar exercícios de cardio aos dias apropriados
          if (cardioExercises.length > 0) {
            console.log('Total de exercícios de cardio encontrados:', cardioExercises.length)

            // Para cada exercício de cardio, adicionar ao dia correspondente
            for (let cardioExercise of cardioExercises) {
              // Encontrar o dia correspondente baseado no grupo
              let targetDay = state.daysOfWeek.find(
                (day) =>
                  day.base_group_name === cardioExercise.group_name ||
                  day.exercises.some(
                    (ex) => ex.training_plan_group_id === cardioExercise.training_plan_group_id,
                  ),
              )

              if (targetDay) {
                console.log(
                  'Adicionando cardio ao dia:',
                  targetDay.day,
                  'Grupo:',
                  cardioExercise.training_plan_group_id,
                )

                // Marcar como exercício de cardio
                cardioExercise.is_cardio = true

                // Garantir que não tenha series
                if (cardioExercise.series) {
                  delete cardioExercise.series
                }

                // Inicializar cardio_details se não existir
                if (!cardioExercise.cardio_details || cardioExercise.cardio_details.length === 0) {
                  cardioExercise.cardio_details = [
                    {
                      stage: '',
                      time: '',
                      distance: '',
                      recovery_time: '',
                      load: '',
                      fca: '',
                      pace: '',
                      vo2_per_time: '',
                      fctr: '',
                    },
                  ]
                } else {
                  // Converter os tempos para o formato correto da interface
                  cardioExercise.cardio_details = cardioExercise.cardio_details.map((detail) => ({
                    stage: detail.stage || '',
                    time: converterTempoParaInterface(detail.time, true),
                    distance: detail.distance || '',
                    recovery_time: converterTempoParaInterface(detail.recovery_time, true),
                    load: detail.load || '',
                    fca: detail.fca || '',
                    pace: detail.pace || '',
                    vo2_per_time: detail.vo2_per_time || '',
                    fctr: detail.fctr || '',
                  }))
                }

                targetDay.exercises.push(cardioExercise)
              } else {
                console.log(
                  'Dia não encontrado para cardio do grupo:',
                  cardioExercise.training_plan_group_id,
                )
              }
            }
          }

          buscarTotalizadores()
          buscarTotalizadoresCardio() // ✅ Buscar totais de cardio do backend
        }
      } catch (error) {
        console.log(error)
        store.commit('SET_SPLASH_SCREEN', false)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarTotalizadores = async () => {
      let response = await kpiRepository.TrainingAverageTotalsGet(
        state.planoTreinoId,
        state.selectedWeek,
      )
      if (response.data.success) {
        state.totals = response.data.data
      }
    }

    // ✅ Função para buscar totalizadores de cardio do backend (semana, plano, acumulado)
    const buscarTotalizadoresCardio = async () => {
      if (!state.planoTreinoId || !state.selectedWeek) {
        state.totalsCardio = null
        return
      }

      try {
        let response = await kpiRepository.CardioTotalsGet(
          state.planoTreinoId,
          state.selectedWeek,
        )
        if (response.data.success) {
          const data = response.data.data
          // Verificar se tem dados de cardio (pelo menos um valor > 0)
          const hasCardioData =
            (data.week?.estagios > 0 || data.week?.distancia > 0) ||
            (data.plan?.estagios > 0 || data.plan?.distancia > 0) ||
            (data.accumulated?.estagios > 0 || data.accumulated?.distancia > 0)

          if (hasCardioData) {
            state.totalsCardio = data
          } else {
            state.totalsCardio = null
          }
        }
      } catch (error) {
        console.error('Erro ao buscar totais de cardio:', error)
        state.totalsCardio = null
      }
    }

    const buscarPlanoDetreinoSemanas = async () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await planosTreinoRepository.SemanasDiasGet()
        state.semanas = []
        if (response.data.success) {
          state.semanas = response.data.data.map((item, index) => {
            //item['copiar'] = false
            item['name'] = `Sem. ${index + 1}`
            return item
          })
          state.semanasSelect = [...state.semanas]
          // state.semanasSelect.unshift({id: 0, copiar: false, name: 'Selecionar tudo' })
        }

        store.commit('SET_SPLASH_SCREEN', false)
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        swal({
          icon: 'error',
          title: 'Erro ao listar semanas do plano de treino!',
          text: error.message,
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarDadosPlanoTreino = async () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await planosTreinoRepository.PlanosTreinoGetById(state.planoTreinoId)
        store.commit('SET_SPLASH_SCREEN', false)
        if (response.data.success) {
          state.planoTreino = response.data.data

          await buscarExerciciosTestados()
          if (route.query.week && parseInt(route.query.week) > 0) {
            state.selectedWeek = parseInt(route.query.week)
            await buscarTreinoSemana()
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        swal({
          icon: 'error',
          title: 'Erro ao listar dados do plano de treino!',
          text: error.message,
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarExerciciosTestados = async () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await testesCargaRepository.ExerciciosTestadosPorPlanoTreinoId(
          state.planoTreinoId,
        )
        store.commit('SET_SPLASH_SCREEN', false)
        if (response.data.success) {
          state.exerciciosTestados = response.data.data
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        swal({
          icon: 'error',
          title: 'Erro ao listar exercicios testados!',
          text: error.message,
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarModalidade = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      modalidadeRepository
        .ModalidadeGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.modalidades = response.data.data
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao buscar modalidade!',
            text: error.message,
          })
        })
    }

    const buscarMetodos = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      metodoRepository
        .MetodoGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.metodos = response.data.data
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao buscar métodos!',
            text: error.message,
          })
        })
    }

    const adicionarIntervalo = () => {
      const novoIntervalo = {
        estagio: '',
        tempo: '',
        distancia: '',
      }

      if (isMetodoIntervalado()) {
        novoIntervalo.tempo_recuperacao = ''
        novoIntervalo.carga = ''
        novoIntervalo.fca = ''
      }

      if (isMetodoContinuo()) {
        novoIntervalo.pace = ''
        novoIntervalo.vo2_t = ''
        novoIntervalo.fctr = ''
      }

      state.cardio.intervalos.push(novoIntervalo)
    }

    const removerUltimoIntervalo = () => {
      if (state.cardio.intervalos.length > 0) {
        state.cardio.intervalos.pop()
      }
    }

    const calcularTotais = () => {
      if (state.cardio.intervalos.length === 0) {
        swal({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Não há intervalos para calcular.',
        })
        return
      }

      const resumo = {
        somaEstagio: 0,
        somaTempo: 0,
        somaDistancia: 0,
        somaRecuperacao: 0,
        mediaPace: 0,
        mediaCarga: 0,
        mediaVo2t: 0, // Para método contínuo
        mediaFca: 0, // Para método intervalado
      }

      let totalPace = 0
      let totalCarga = 0
      let totalVo2t = 0
      let totalFca = 0
      let countPace = 0
      let countCarga = 0
      let countVo2t = 0
      let countFca = 0

      state.cardio.intervalos.forEach((intervalo) => {
        // Somatórios (comuns para ambos os métodos)
        resumo.somaEstagio += parseInt(intervalo.estagio) || 0

        // Para tempo: multiplicar pelo número de estágios
        const estagios = parseInt(intervalo.estagio) || 0
        const tempo = converterTempoParaSegundos(intervalo.tempo)
        resumo.somaTempo += estagios * tempo

        // Para distância: multiplicar pelo número de estágios
        const distancia = parseInt(intervalo.distancia) || 0
        resumo.somaDistancia += estagios * distancia

        if (isMetodoContinuo()) {
          // Campos específicos do método contínuo
          if (intervalo.pace && !isNaN(parseFloat(intervalo.pace))) {
            totalPace += parseFloat(intervalo.pace)
            countPace++
          }
          if (intervalo.vo2_t && !isNaN(parseFloat(intervalo.vo2_t))) {
            totalVo2t += parseFloat(intervalo.vo2_t)
            countVo2t++
          }
        }

        if (isMetodoIntervalado()) {
          // Campos específicos do método intervalado
          // Para tempo de recuperação: multiplicar pelo número de estágios
          const estagios = parseInt(intervalo.estagio) || 0
          const tempoRecuperacao = converterTempoParaSegundos(intervalo.tempo_recuperacao)
          resumo.somaRecuperacao += estagios * tempoRecuperacao
          if (intervalo.carga && !isNaN(parseFloat(intervalo.carga))) {
            const estagios = parseInt(intervalo.estagio) || 0
            totalCarga += parseFloat(intervalo.carga) * estagios
            countCarga++
          }
          if (intervalo.fca && !isNaN(parseFloat(intervalo.fca))) {
            const estagios = parseInt(intervalo.estagio) || 0
            totalFca += parseFloat(intervalo.fca) * estagios
            countFca++
          }
        }
      })

      // Calcular médias baseado no método
      if (isMetodoContinuo()) {
        resumo.mediaPace = countPace > 0 ? (totalPace / countPace).toFixed(1) : 0
        resumo.mediaVo2t = countVo2t > 0 ? (totalVo2t / countVo2t).toFixed(1) : 0
      }

      if (isMetodoIntervalado()) {
        // Para médias, dividir pelo total de estágios, não pelo número de linhas
        const totalEstagios = state.cardio.intervalos.reduce((total, intervalo) => {
          return total + (parseInt(intervalo.estagio) || 0)
        }, 0)

        resumo.mediaCarga = totalEstagios > 0 ? (totalCarga / totalEstagios).toFixed(1) : 0
        resumo.mediaFca = totalEstagios > 0 ? (totalFca / totalEstagios).toFixed(1) : 0
      }

      state.cardio.resumo = resumo

      const metodoNome = isMetodoContinuo() ? 'Contínuo' : 'Intervalado'
      swal({
        icon: 'success',
        title: 'Totais Calculados!',
        text: `Os somatórios e médias do método ${metodoNome} foram calculados com sucesso.`,
      })
    }

    const getTituloTreinamentoCardio = () => {
      if (!state.cardio.cardio_method_id) return 'Treinamento Cardio'

      const metodoSelecionado = state.metodos.find((m) => m.id === state.cardio.cardio_method_id)
      if (!metodoSelecionado) return 'Treinamento Cardio'

      return metodoSelecionado.name || 'Treinamento Cardio'
    }

    const mudarTipoTreino = (tipo) => {
      state.trainingType = tipo
      state.grupoSoCardio = false // ✅ Reset do aviso ao mudar tipo de treino
      state.trainingPlanGroupId = '' // ✅ Reset do select de grupo ao mudar tipo de treino

      // Se mudou para cardio, limpar exercícios e esperar seleção da modalidade
      if (tipo === 'cardio') {
        state.exercicios = []
        state.gruposCardio = []
        state.cardio.cardio_modality_id = 0
        state.cardio.cardio_grupo_id = 0
        state.cardio.cardio_exercise_id = 0
      }

      // Se mudou para peso, limpar exercícios elaborados
      if (tipo === 'peso') {
        state.treinoElaborado = []
      }
    }

    const carregarTodosExercicios = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      exercicioRepository
        .ExercicioGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.exercicios = response.data.data
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao buscar exercícios!',
            text: error.message,
          })
        })
    }

    const isMetodoIntervalado = () => {
      if (!state.cardio.cardio_method_id) return false
      const metodoSelecionado = state.metodos.find((m) => m.id === state.cardio.cardio_method_id)
      return metodoSelecionado?.name?.toLowerCase().includes('intervalado') || false
    }

    const isMetodoContinuo = () => {
      if (!state.cardio.cardio_method_id) return false
      const metodoSelecionado = state.metodos.find((m) => m.id === state.cardio.cardio_method_id)
      return (
        metodoSelecionado?.name?.toLowerCase().includes('contínuo') ||
        metodoSelecionado?.name?.toLowerCase().includes('continuo') ||
        false
      )
    }

    const getColunaTempo = () => {
      if (isMetodoContinuo()) {
        return 'Tempo (Hora/Min/Seg)'
      }
      return 'Tempo (Min/seg)'
    }

    const getPlaceholderTempo = () => {
      if (isMetodoContinuo()) {
        return '00:00:00'
      }
      return '00:00'
    }

    const getMascaraTempo = () => {
      if (isMetodoContinuo()) {
        return '##:##:##'
      }
      return '##:##'
    }

    const getTextoBotao = () => {
      if (isMetodoContinuo()) {
        return 'Estágio'
      }
      return 'Intervalo'
    }

    const buscarGrupoPorModalidade = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      grupoRepository
        .GrupoGetByModalityId(state.modalidadeSelecionadaId)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.grupos = response.data.data
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao buscar grupos!',
            text: error.message,
          })
        })
    }

    const buscarExercicioPorGrupo = (id = null) => {
      store.commit('SET_SPLASH_SCREEN', true)
      exercicioRepository
        .ExercicioGetByGroupId(state.grupoSelecionadoId)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.exercicios = response.data.data
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao buscar exercicios!',
            text: error.message,
          })
        })
    }

    const buscarGrupoPorModalidadeCardio = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      grupoRepository
        .GrupoGetByModalityId(state.cardio.cardio_modality_id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.gruposCardio = response.data.data
            // Limpar seleções dependentes
            state.cardio.cardio_grupo_id = 0
            state.cardio.cardio_exercise_id = 0
            state.exercicios = []
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao buscar grupos de cardio!',
            text: error.message,
          })
        })
    }

    const buscarExercicioPorGrupoCardio = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      exercicioRepository
        .ExercicioGetByGroupId(state.cardio.cardio_grupo_id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.exercicios = response.data.data
            // Limpar seleção de exercício
            state.cardio.cardio_exercise_id = 0
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao buscar exercícios de cardio!',
            text: error.message,
          })
        })
    }

    function adicionarExercicio(tipoLista = '') {
      if (tipoLista == 'T') {
        // EXERCÍCIOS TESTADOS
        if (state.testedExerciseSelected == '0') {
          // Adicionar todos os exercícios testados
          state.exerciciosTestados.forEach((item) => {
            let obj = {
              order: state.treinoElaborado.length + 1,
              exercise: Object.assign({}, item.exercise),
              max_load_test: item.max_load_test,
              exercise_id: item.exercise.id,
              series: [
                {
                  repetitions: '',
                  load: '',
                  perc_load: '',
                  series: '',
                },
              ],
            }

            // Verificar em qual aba estamos
            if (state.selectedTab == 'elaborador') {
              // Adicionar no elaborador geral (grupos)
              if (!verificaExericioDuplicado(state.treinoElaborado, obj, obj.exercise_id)) {
                state.treinoElaborado.push(obj)
              }
            } else {
              // Adicionar no dia específico
              let dayIndex = state.daysOfWeek.findIndex((x) => x.day == state.selectedTab)
              if (dayIndex !== -1) {
                obj.order = state.daysOfWeek[dayIndex].exercises.length + 1
                if (!verificaExericioDuplicado(state.daysOfWeek[dayIndex].exercises, obj, obj.exercise_id)) {
                  let exercises = [...state.daysOfWeek[dayIndex].exercises]
                  if (exercises.length > 0) {
                    let lastExercise = exercises[exercises.length - 1]
                    obj['training_day'] = lastExercise.training_day
                    obj['training_plan_week_id'] = lastExercise.training_plan_week_id
                    obj['training_date'] = lastExercise.training_date
                  }
                  exercises.push(obj)
                  state.daysOfWeek[dayIndex].exercises = [...exercises]
                }
              }
            }
          })
          state.testedExerciseSelected = ''
        } else {
          // Adicionar um exercício testado específico
          let exercise = state.exerciciosTestados.find(
            (x) => x.id == parseInt(state.testedExerciseSelected),
          )

          if (!exercise) {
            state.testedExerciseSelected = ''
            return
          }

          let obj = {
            order: state.treinoElaborado.length + 1,
            exercise: Object.assign({}, exercise.exercise),
            exercise_id: exercise.exercise.id,
            max_load_test: exercise.max_load_test,
            series: [
              {
                repetitions: '',
                load: '',
                perc_load: '',
                series: '',
              },
            ],
          }

          // Verificar em qual aba estamos
          if (state.selectedTab == 'elaborador') {
            // Adicionar no elaborador geral (grupos)
            if (verificaExericioDuplicado(state.treinoElaborado, obj, obj.exercise_id)) {
              state.testedExerciseSelected = ''
              return
            }
            state.treinoElaborado.push(obj)
          } else {
            // Adicionar no dia específico
            let dayIndex = state.daysOfWeek.findIndex((x) => x.day == state.selectedTab)

            if (dayIndex === -1) {
              state.testedExerciseSelected = ''
              return
            }

            obj.order = state.daysOfWeek[dayIndex].exercises.length + 1

            if (verificaExericioDuplicado(state.daysOfWeek[dayIndex].exercises, obj, obj.exercise_id)) {
              state.testedExerciseSelected = ''
              return
            }

            let exercises = [...state.daysOfWeek[dayIndex].exercises]
            if (exercises.length > 0) {
              let lastExercise = exercises[exercises.length - 1]
              obj['training_day'] = lastExercise.training_day
              obj['training_plan_week_id'] = lastExercise.training_plan_week_id
              obj['training_date'] = lastExercise.training_date
            }
            exercises.push(obj)
            state.daysOfWeek[dayIndex].exercises = [...exercises]
          }

          state.testedExerciseSelected = ''
        }
      } else {
        let exercise = state.exercicios.find((x) => x.id == parseInt(state.exercicioSelecionadoId))

        //if(verificaExericioDuplicado(exercise, exercise.id)) return
        let obj = {
          order: state.treinoElaborado.length + 1,
          exercise: exercise,
          exercise_id: exercise.id,
          max_load_test: 0,
          series: [
            {
              repetitions: '',
              load: '',
              perc_load: '',
              series: '',
            },
          ],
        }

        if (state.selectedTab == 'elaborador') {
          if (verificaExericioDuplicado(state.treinoElaborado, obj, obj.exercise_id)) {
            // ✅ CORREÇÃO: Resetar select mesmo quando há duplicata
            state.exercicioSelecionadoId = '0'
            return
          }
          console.log('➕ [ElaborarTreino] Adicionando exercício NÃO testado')
          console.log('📊 Antes:', state.treinoElaborado.length, 'exercícios')
          state.treinoElaborado.push(obj)
          console.log('📊 Depois:', state.treinoElaborado.length, 'exercícios')
          console.log('📋 Lista completa:', state.treinoElaborado.map(ex => ex.exercise.name))
          // ✅ CORREÇÃO: Resetar select após adicionar para evitar duplicação
          state.exercicioSelecionadoId = '0'
        } else {
          let dayIndex = state.daysOfWeek.findIndex((x) => x.day == state.selectedTab)

          if (verificaExericioDuplicado(state.daysOfWeek[dayIndex].exercises, obj, obj.exercise_id)) {
            // ✅ CORREÇÃO: Resetar select mesmo quando há duplicata
            state.exercicioSelecionadoId = '0'
            return
          }

          obj.order = state.daysOfWeek[dayIndex].exercises.length + 1
          let exercises = [...state.daysOfWeek[dayIndex].exercises]
          let lastExercise = exercises[exercises.length - 1]

          obj['training_day'] = lastExercise.training_day
          obj['training_plan_week_id'] = lastExercise.training_plan_week_id
          obj['training_date'] = lastExercise.training_date
          obj['exercise_id'] = obj.exercise.id
          exercises.push(obj)
          //state.daysOfWeek[dayIndex].exercises.push(obj)
          state.daysOfWeek[dayIndex].exercises = [...exercises]
          // ✅ CORREÇÃO: Resetar select após adicionar para evitar duplicação
          state.exercicioSelecionadoId = '0'
        }
      }
    }

    function verificaExericioDuplicado(listExercises, exercise, exerciseId) {
      /*let exercicioDuplicado = false
      listExercises.forEach(item => {
        if(item['exercise_id'] == exerciseId) {
          exercicioDuplicado = true
        }
      })

      return exercicioDuplicado*/
      return listExercises.some((item) => item['exercise_id'] == exerciseId)
    }

    // ✅ NOVA FUNÇÃO: Verificar se exercício já foi adicionado (para mostrar ícone ✓)
    function exercicioJaAdicionado(exerciseId) {
      // Verifica se está na aba do elaborador ou em um dia específico
      if (state.selectedTab == 'elaborador') {
        // Verifica no elaborador geral
        return verificaExericioDuplicado(state.treinoElaborado, null, exerciseId)
      } else {
        // Verifica no dia específico
        let dayIndex = state.daysOfWeek.findIndex((x) => x.day == state.selectedTab)
        if (dayIndex !== -1) {
          return verificaExericioDuplicado(state.daysOfWeek[dayIndex].exercises, null, exerciseId)
        }
      }
      return false
    }

    // ✅ NOVA FUNÇÃO: Atualizar exercícios do grupo (elaborador) quando o filho emitir mudanças
    function atualizarExerciciosGrupo(novosExercicios) {
      console.log('📥 [ElaborarTreino GRUPO] Recebeu update do filho:', novosExercicios.length, 'exercícios')
      state.treinoElaborado = novosExercicios
    }

    // ✅ NOVA FUNÇÃO: Atualizar exercícios do dia quando o filho emitir mudanças
    function atualizarExerciciosDia(dayName, novosExercicios) {
      console.log('📥 [ElaborarTreino DIA] Recebeu update do filho:', novosExercicios.length, 'exercícios para dia', dayName)
      const dayIndex = state.daysOfWeek.findIndex(d => d.day === dayName)
      if (dayIndex > -1) {
        state.daysOfWeek[dayIndex].exercises = novosExercicios
        console.log('✅ [ElaborarTreino DIA] Atualizado state.daysOfWeek[' + dayIndex + '].exercises para', novosExercicios.length, 'exercícios')
      }
    }

    // ✅ NOVA FUNÇÃO: Adicionar exercício direto na aba
    function adicionarExercicioNaAba(dayName) {
      if (!state.testedExerciseSelectedTab) return

      const exercise = state.exerciciosTestados.find(
        (x) => x.id == parseInt(state.testedExerciseSelectedTab),
      )

      if (!exercise) return

      const dayIndex = state.daysOfWeek.findIndex((x) => x.day == dayName)

      if (dayIndex === -1) return

      let obj = {
        order: state.daysOfWeek[dayIndex].exercises.length + 1,
        exercise: Object.assign({}, exercise.exercise),
        exercise_id: exercise.exercise.id,
        max_load_test: exercise.max_load_test,
        series: [
          {
            repetitions: '',
            load: '',
            perc_load: '',
            series: '',
          },
        ],
      }

      // Verificar duplicata
      if (verificaExericioDuplicado(state.daysOfWeek[dayIndex].exercises, obj, obj.exercise_id)) {
        state.testedExerciseSelectedTab = ''
        return
      }

      let exercises = [...state.daysOfWeek[dayIndex].exercises]

      if (exercises.length > 0) {
        let lastExercise = exercises[exercises.length - 1]
        obj['training_day'] = lastExercise.training_day
        obj['training_plan_week_id'] = lastExercise.training_plan_week_id
        obj['training_date'] = lastExercise.training_date
        obj['exercise_id'] = obj.exercise.id
      }

      exercises.push(obj)
      state.daysOfWeek[dayIndex].exercises = [...exercises]

      // Reset do select
      state.testedExerciseSelectedTab = ''
    }

    const adicionarExerciciosGrupo = async () => {
      if (state.trainingType === 'peso') {
        // Lógica existente para exercícios de peso
        let exercicios = state.treinoElaborado.map((item, index) => {
          item['order'] = index + 1
          return item
        })

        let obj = {
          trainingPlanId: state.planoTreinoId,
          exercises: exercicios,
          training_plan_group_id: parseInt(state.trainingPlanGroupId),
          observation: state.observation,
        }

        // ✅ DEBUG: Log detalhado do payload antes de enviar
        console.log('📤 [ElaborarTreino] Payload a ser enviado:', JSON.stringify(obj, null, 2))
        console.log('📤 [ElaborarTreino] Séries do primeiro exercício:', obj.exercises[0]?.series)

        try {
          state.btnSalvarExerciciosDisabled = true
          store.commit('SET_SPLASH_SCREEN', true)

          let response = await planosTreinoRepository.AdicionarExerciciosGrupoPost(obj)

          if (response.data.success) {
            // ✅ FIX: Limpar apenas o array de exercícios não testados, sem fazer reload
            state.treinoElaborado = []
            state.observation = ''
            state.trainingPlanGroupId = '' // ✅ Reset do select de grupo após salvar

            swal({
              icon: 'success',
              title: 'Exercicíos adicionados com sucesso!',
            })
            // ✅ FIX: NÃO chamar buscarTreinoSemana() para evitar recarregar exercícios deletados
            // Se precisar atualizar, o usuário pode trocar de aba ou recarregar manualmente
          }
        } catch (error) {
          console.log(error)
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao salvar exercicios!',
            text: error.message,
          })
        } finally {
          state.btnSalvarExerciciosDisabled = false
          store.commit('SET_SPLASH_SCREEN', false)
        }
      } else if (state.trainingType === 'cardio') {
        // Lógica para exercícios de cardio

        // Validações dos campos obrigatórios
        if (!state.trainingPlanGroupId || state.trainingPlanGroupId === 0) {
          swal({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Por favor, selecione um grupo de treino antes de salvar.',
          })
          return
        }

        if (!validarCardioExerciseId()) {
          swal({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Por favor, selecione um exercício de cardio válido antes de salvar.',
          })
          return
        }

        if (!state.cardio.cardio_method_id || state.cardio.cardio_method_id === 0) {
          swal({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Por favor, selecione um método de cardio antes de salvar.',
          })
          return
        }

        if (!state.cardio.cardio_modality_id || state.cardio.cardio_modality_id === 0) {
          swal({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Por favor, selecione uma modalidade de cardio antes de salvar.',
          })
          return
        }

        // Validar se há pelo menos um intervalo preenchido
        const intervalosValidos = state.cardio.intervalos.filter(
          (intervalo) => intervalo.estagio && intervalo.tempo && intervalo.distancia,
        )

        if (intervalosValidos.length === 0) {
          swal({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Por favor, preencha pelo menos um intervalo de cardio antes de salvar.',
          })
          return
        }

        let obj = {
          training_plan_group_id: parseInt(state.trainingPlanGroupId),
          cardio_modality_id: state.cardio.cardio_modality_id,
          cardio_method_id: state.cardio.cardio_method_id,
          vo2_max: state.cardio.vo2_max || null,
          fcm: state.cardio.fcm || null,
          perc_vo2_max: state.cardio.vo2_percent || null,
          perc_fcm: state.cardio.fcm_percent || null,
          observation: state.observation,
          exercises: [
            {
              exercise: {
                id: parseInt(state.cardio.cardio_exercise_id), // Garantir que é um número
              },
              order: 1,
              cardio_details: state.cardio.intervalos.map((intervalo, index) => {
                const detail = {
                  stage: parseInt(intervalo.estagio) || 1,
                  time: converterTempoParaAPI(intervalo.tempo),
                  distance: parseInt(intervalo.distancia) || 0,
                  recovery_time: converterTempoParaAPI(intervalo.tempo_recuperacao),
                  load: parseInt(intervalo.carga) || 0,
                  fca: parseInt(intervalo.fca) || 0,
                  pace: parseFloat(intervalo.pace) || 0,
                  vo2_per_time: parseFloat(intervalo.vo2_t) || 0,
                  fctr: parseInt(intervalo.fctr) || 0,
                }
                console.log(`Intervalo ${index} sendo enviado:`, detail)
                console.log(
                  `Campo vo2_t sendo enviado: ${intervalo.vo2_t} -> ${detail.vo2_per_time}`,
                )
                return detail
              }),
            },
          ],
        }

        console.log('Cardio Exercise ID:', state.cardio.cardio_exercise_id)
        console.log('Tipo do Cardio Exercise ID:', typeof state.cardio.cardio_exercise_id)
        console.log('Objeto sendo enviado para API:', JSON.stringify(obj, null, 2))
        console.log('Exercise object sendo enviado:', obj.exercises[0].exercise)

        // Validação adicional do objeto exercise
        if (!obj.exercises[0].exercise.id || obj.exercises[0].exercise.id === 0) {
          console.error('ERRO: Exercise ID inválido sendo enviado:', obj.exercises[0].exercise)
          swal({
            icon: 'error',
            title: 'Erro interno!',
            text: 'ID do exercício inválido. Por favor, tente novamente.',
          })
          return
        }

        try {
          state.btnSalvarExerciciosDisabled = true
          store.commit('SET_SPLASH_SCREEN', true)

          let response

          // Verificar se já existe um exercício de cardio para fazer update
          if (state.existingCardioExerciseId) {
            console.log(
              'Fazendo UPDATE do exercício de cardio existente:',
              state.existingCardioExerciseId,
            )
            response = await planosTreinoRepository.PlanoTreinoAtualizarExerciciosCardioPorId(
              state.existingCardioExerciseId,
              obj,
            )
          } else {
            console.log('Fazendo POST para criar novo exercício de cardio')
            response = await planosTreinoRepository.AdicionarExerciciosCardioGrupoPost(obj)
          }

          if (response.data.success) {
            // Limpar os campos do formulário
            state.cardio = {
              cardio_method_id: 0,
              cardio_modality_id: 0,
              vo2_max: '',
              fcm: '',
              vo2_percent: '',
              fcm_percent: '',
              intervalos: [
                {
                  estagio: '',
                  tempo: '',
                  distancia: '',
                  tempo_recuperacao: '',
                  carga: '',
                  fca: '',
                  pace: '',
                  vo2_t: '',
                  fctr: '',
                },
              ],
            }
            state.existingCardioExerciseId = null
            state.trainingPlanGroupId = ''
            state.observation = ''

            swal({
              icon: 'success',
              title: state.existingCardioExerciseId
                ? 'Exercícios de cardio atualizados com sucesso!'
                : 'Exercícios de cardio adicionados com sucesso!',
            })
            // ✅ FIX: NÃO chamar buscarTreinoSemana() para evitar recarregar exercícios deletados
          }
        } catch (error) {
          console.log(error)
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao salvar exercícios de cardio!',
            text: error.message,
          })
        } finally {
          state.btnSalvarExerciciosDisabled = false
          store.commit('SET_SPLASH_SCREEN', false)
        }
      }
    }

    const adicionarGruposDias = async () => {
      let obj = {
        weeks: state.semanasSelect,
      }

      // ✅ Mapeamento de dias da semana (abreviação para nome em inglês)
      const diasSemanaMap = {
        'dom': 'Sunday',
        'seg': 'Monday',
        'ter': 'Tuesday',
        'qua': 'Wednesday',
        'qui': 'Thursday',
        'sex': 'Friday',
        'sab': 'Saturday',
      }

      const diasSemanaMapPtBr = {
        'dom': 'Domingo',
        'seg': 'Segunda',
        'ter': 'Terça',
        'qua': 'Quarta',
        'qui': 'Quinta',
        'sex': 'Sexta',
        'sab': 'Sábado',
      }

      // ✅ Verificar se há dias selecionados que não estão nos dias de treino do aluno
      // Tentar obter training_days de várias fontes possíveis
      let trainingDays = state.planoTreino?.students?.[0]?.training_days || []

      // Se training_days estiver vazio, tentar obter de train_days
      if (trainingDays.length === 0) {
        const trainDays = state.planoTreino?.students?.[0]?.train_days || []
        // Converter train_days (Seg, Ter, etc) para o formato esperado (seg, ter, etc)
        const trainDaysMapping = {
          'Dom': 'dom', 'Seg': 'seg', 'Ter': 'ter', 'Qua': 'qua',
          'Qui': 'qui', 'Sex': 'sex', 'Sáb': 'sab', 'Sab': 'sab'
        }
        trainingDays = trainDays.map(d => trainDaysMapping[d] || d.toLowerCase())
      }

      console.log('[Elaborador] Dados do aluno:', state.planoTreino?.students?.[0])
      console.log('[Elaborador] training_days do aluno:', trainingDays)

      if (trainingDays.length > 0) {
        const diasForaDoPlano = []

        for (const week of state.semanasSelect) {
          for (const [dayKey, dayData] of Object.entries(week.days)) {
            // Se tem um grupo selecionado (copiar > 0) e não está bloqueado
            if (dayData.copiar && parseInt(dayData.copiar) > 0 && !dayData.block) {
              // Verificar se esse dia da semana está nos dias de treino do aluno
              if (!trainingDays.includes(dayKey)) {
                const diaPtBr = diasSemanaMapPtBr[dayKey] || dayKey
                const dataFormatada = dayData.date ? new Date(dayData.date).toLocaleDateString('pt-BR') : ''
                diasForaDoPlano.push(`${diaPtBr} (${dataFormatada})`)
              }
            }
          }
        }

        if (diasForaDoPlano.length > 0) {
          const diasPermitidos = trainingDays.map(d => diasSemanaMapPtBr[d] || d).join(', ')
          const resultado = await swal({
            icon: 'warning',
            title: 'Atenção!',
            html: `Você está adicionando treino em dias que <b>não estão nos dias de treino do aluno</b>.<br><br>
                   <b>Dias de treino do aluno:</b> ${diasPermitidos}<br><br>
                   <b>Dias fora do plano:</b><br>${diasForaDoPlano.join('<br>')}<br><br>
                   Deseja continuar mesmo assim?`,
            showCancelButton: true,
            confirmButtonText: 'Sim, continuar',
            cancelButtonText: 'Não, cancelar',
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: 'btn bg-gradient-warning',
              cancelButton: 'btn bg-gradient-secondary',
            },
            buttonsStyling: false,
          })

          console.log('[Elaborador] Resultado do swal:', resultado)

          // Se o usuário clicou em "Não, cancelar" ou fechou o modal, não salva
          if (resultado.isConfirmed !== true) {
            console.log('[Elaborador] Usuário cancelou - não vai salvar os dias fora do plano')
            swal({
              icon: 'info',
              title: 'Operação cancelada',
              text: 'Os dias não foram salvos.',
              timer: 2000,
              showConfirmButton: false
            })
            return // Interrompe a execução e não salva
          }

          console.log('[Elaborador] Usuário confirmou - vai salvar os dias mesmo fora do plano')
        }
      }

      try {
        state.btnSalvarExerciciosDisabled = true
        store.commit('SET_SPLASH_SCREEN', true)

        let response = await planosTreinoRepository.AdicionarGruposDiasPost(obj)

        if (response.data.success) {
          swal({
            icon: 'success',
            title: 'Exercicíos adicionados com sucesso!',
          }).then(() => {
            buscarTreinoSemana()
          })
        }
      } catch (error) {
        console.log(error)
        store.commit('SET_SPLASH_SCREEN', false)
        swal({
          icon: 'error',
          title: 'Erro ao salvar exercicios!',
          text: error.message,
        })
      } finally {
        state.btnSalvarExerciciosDisabled = false
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const limparExercicios = () => {
      if (state.trainingType === 'peso' && state.treinoElaborado.length > 0) {
        const groupId = state.treinoElaborado[0]['training_plan_group_id']
        swal({
          title: 'Tem certeza?',
          text: `Deseja deletar todos exercicios do grupo?`,
          showCancelButton: true,
          confirmButtonText: 'Sim, quero deletar!',
          cancelButtonText: 'Não, cancelar!',
          reverseButtons: true,
          customClass: {
            confirmButton: 'btn bg-gradient-success',
            cancelButton: 'btn bg-gradient-danger',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            deletarExercicioConfirma(groupId)
          }
        })
      } else if (state.trainingType === 'cardio') {
        // Para cardio, usar o mesmo endpoint do peso
        if (state.trainingPlanGroupId) {
          swal({
            title: 'Tem certeza?',
            text: `Deseja deletar todos exercícios de cardio do grupo?`,
            showCancelButton: true,
            confirmButtonText: 'Sim, quero deletar!',
            cancelButtonText: 'Não, cancelar!',
            reverseButtons: true,
            customClass: {
              confirmButton: 'btn bg-gradient-success',
              cancelButton: 'btn bg-gradient-danger',
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.isConfirmed) {
              deletarExercicioConfirma(parseInt(state.trainingPlanGroupId))
            }
          })
        } else {
          // Se não há grupo selecionado, apenas limpar a interface
          state.cardio = {
            cardio_method_id: 0,
            cardio_modality_id: 0,
            vo2_max: '',
            fcm: '',
            vo2_percent: '',
            fcm_percent: '',
            intervalos: [
              {
                estagio: '',
                tempo: '',
                distancia: '',
                // Campos para método intervalado
                tempo_recuperacao: '',
                carga: '',
                fca: '',
                // Campos para método contínuo
                pace: '',
                vo2_t: '',
                fctr: '',
              },
            ],
          }
          // Limpar ID do exercício existente
          state.existingCardioExerciseId = null

          swal({
            title: 'Limpo!',
            text: 'Dados de cardio limpos com sucesso!',
            icon: 'success',
            customClass: {
              confirmButton: 'btn bg-gradient-success',
            },
            buttonsStyling: false,
          })
        }
      }
    }

    function deletarExercicioConfirma(groupId) {
      store.commit('SET_SPLASH_SCREEN', true)

      if (state.trainingType === 'peso') {
        planosTreinoRepository
          .PlanoTreinoExercicioByGrupoIdDelete(groupId)
          .then(function (response) {
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              swal({
                title: 'Removido!',
                text: 'Exercicios removidos com sucesso!',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn bg-gradient-success',
                },
                buttonsStyling: false,
              })
              state.treinoElaborado = []
            }
          })
          .catch((error) => {
            store.commit('SET_SPLASH_SCREEN', false)
            console.error(error.message)
            swal({
              icon: 'error',
              title: 'Erro ao deletar exercicios!',
              text: error.message,
            })
          })
      } else if (state.trainingType === 'cardio') {
        planosTreinoRepository
          .PlanoTreinoExercicioCardioByGrupoIdDelete(groupId)
          .then(function (response) {
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              swal({
                title: 'Removido!',
                text: 'Exercicios de cardio removidos com sucesso!',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn bg-gradient-success',
                },
                buttonsStyling: false,
              })
              // Limpar dados de cardio
              state.cardio = {
                cardio_method_id: 0,
                cardio_modality_id: 0,
                vo2_max: '',
                fcm: '',
                vo2_percent: '',
                fcm_percent: '',
                intervalos: [
                  {
                    estagio: '',
                    tempo: '',
                    distancia: '',
                    // Campos para método intervalado
                    tempo_recuperacao: '',
                    carga: '',
                    fca: '',
                    // Campos para método contínuo
                    pace: '',
                    vo2_t: '',
                    fctr: '',
                  },
                ],
              }
              // Limpar ID do exercício existente
              state.existingCardioExerciseId = null
            }
          })
          .catch((error) => {
            store.commit('SET_SPLASH_SCREEN', false)
            console.error(error.message)
            swal({
              icon: 'error',
              title: 'Erro ao deletar exercicios de cardio!',
              text: error.message,
            })
          })
      }
    }

    function removerDiaSemana(day, item, index) {
      swal({
        title: 'Tem certeza?',
        text: `Deseja deletar ${day}`,
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          let ids = item.exercises.map((exercise) => {
            return exercise.id
          })
          removerDiaSemanaConfirma(ids, index)
        }
      })
    }

    function removerDiaSemanaConfirma(ids, index) {
      store.commit('SET_SPLASH_SCREEN', true)
      planosTreinoRepository
        .SemanaDiaDelete(ids)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            state.daysOfWeek.splice(index, 1)
            swal({
              title: 'Removido!',
              text: 'Dia removido com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              // listarMetodos()
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: 'Erro ao deletar dia!',
            text: error.message,
          })
        })
    }

    function totalizadoresEstrategicos(tipo) {
      // let totais = {'S': 0, 'REP': 0,	'TON': 0,	'PM': 0,	'IMR': 0}
      let response = 0
      let responseIMR = 0
      let ton = 0
      let rep = 0
      state.daysOfWeek.forEach((day) => {
        day.exercises.forEach((exercise) => {
          // Só calcular para exercícios de peso (que têm series)
          if (!exercise.is_cardio && exercise.series) {
            if (tipo == 'S') {
              exercise.series.forEach((load) => {
                if (load.series != '' && parseInt(load.series) > 0) {
                  response += parseInt(load.series)
                }
              })
            } else if (tipo == 'REP') {
              exercise.series.forEach((load) => {
                if (load.series != '' && load.repetitions != '') {
                  response += parseInt(load.series) * parseInt(load.repetitions)
                }
              })
            } else if (tipo == 'TON') {
              exercise.series.forEach((load) => {
                if (load.series != '' && load.load != '' && load.repetitions != '') {
                  response +=
                    parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)
                }
              })
            } else if (tipo == 'PM') {
              exercise.series.forEach((load) => {
                if (load.load != '' && load.series != '' && load.repetitions != '') {
                  ton += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)

                  rep += parseInt(load.series) * parseInt(load.repetitions)
                  //response += (parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)) / (parseInt(load.series) * parseInt(load.repetitions))
                }
              })
              if (rep > 0) {
                response = parseFloat(ton / rep).toFixed(2)
              }
            } else if (tipo == 'IMR') {
              /*let ton = 0
              let rep = 0*/

              exercise.series.forEach((load) => {
                if (load.load != '' && load.series != '' && load.repetitions != '') {
                  ton += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)

                  rep += parseInt(load.series) * parseInt(load.repetitions)
                  //response += (parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)) / (parseInt(load.series) * parseInt(load.repetitions))
                }

                /*if(load.series != '') {
                  response += parseInt(load.series)
                }*/
              })
              if (rep > 0) {
                let pm = parseFloat(ton / rep).toFixed(2)
                if (exercise.max_load_test) {
                  responseIMR += (pm * 100) / exercise.max_load_test
                }
              }
            }
          }
        })
      })
      if (tipo == 'IMR') {
        //return parseFloat(responseIMR) > 0 ? parseFloat(responseIMR).toFixed(2) : parseFloat(responseIMR)
        return parseInt(responseIMR)
      }
      return response
    }

    // METODO PARA BUSCAR OS EXERCICIOS DO GRUPO DE EXERCICIOS
    function buscaExercicioGrupoTreino() {
      // Reset do aviso de grupo de cardio
      state.grupoSoCardio = false

      if (state.trainingType === 'peso') {
        planosTreinoRepository
          .ExerciciosPorGrupoIdGet(parseInt(state.trainingPlanGroupId))
          .then((response) => {
            state.treinoElaborado = []
            if (response.data.success && response.data.data.length > 0) {
              response.data.data.forEach((item) => {
                item['checkCopy'] = false
                state.treinoElaborado.push(item)
              })
            } else {
              // ✅ Se não tem exercícios de peso, verificar se tem exercícios de cardio
              planosTreinoRepository
                .ExerciciosCardioPorGrupoIdGet(parseInt(state.trainingPlanGroupId))
                .then((cardioResponse) => {
                  if (cardioResponse.data.success && cardioResponse.data.data.length > 0) {
                    // Grupo só tem cardio - mostrar aviso
                    state.grupoSoCardio = true
                  }
                })
                .catch((error) => {
                  console.error('Erro ao verificar cardio:', error)
                })
            }
          })
          .catch((error) => {
            console.error(error)
          })
      } else if (state.trainingType === 'cardio') {
        // Usar endpoint específico para cardio
        planosTreinoRepository
          .ExerciciosCardioPorGrupoIdGet(parseInt(state.trainingPlanGroupId))
          .then((response) => {
            console.log('Resposta da API para cardio:', response.data)
            if (response.data.success && response.data.data.length > 0) {
              const cardioExercises = response.data.data
              console.log('Exercícios de cardio encontrados:', cardioExercises)
              console.log(
                'Estrutura completa do primeiro exercício:',
                JSON.stringify(cardioExercises[0], null, 2),
              )
              console.log(
                'Cardio details do primeiro exercício:',
                cardioExercises[0]?.cardio_details,
              )
              if (cardioExercises[0]?.cardio_details?.length > 0) {
                console.log('Primeiro cardio detail:', cardioExercises[0].cardio_details[0])
                console.log(
                  'VO2 do primeiro detail:',
                  cardioExercises[0].cardio_details[0].vo2_per_time,
                )
              }

              // Pegar o primeiro exercício de cardio (assumindo que há apenas um)
              const cardioExercise = cardioExercises[0]

              // Armazenar o ID do exercício existente para update
              state.existingCardioExerciseId = cardioExercise.id

              // Verificar se há dados de cardio no exercício
              if (
                cardioExercise.cardio_modality_id ||
                cardioExercise.cardio_method_id ||
                cardioExercise.perc_vo2_max ||
                cardioExercise.perc_fcm
              ) {
                // Preencher os campos de cardio
                state.cardio.cardio_modality_id = cardioExercise.cardio_modality_id || 0
                state.cardio.cardio_method_id = cardioExercise.cardio_method_id || 0
                state.cardio.cardio_exercise_id = cardioExercise.exercise_id || 0 // Definir o ID do exercício
                state.cardio.vo2_percent = cardioExercise.perc_vo2_max || ''
                state.cardio.fcm_percent = cardioExercise.perc_fcm || ''

                console.log('Campos de cardio preenchidos:', {
                  modality: state.cardio.cardio_modality_id,
                  method: state.cardio.cardio_method_id,
                  exercise_id: state.cardio.cardio_exercise_id,
                  vo2_percent: state.cardio.vo2_percent,
                  fcm_percent: state.cardio.fcm_percent,
                })

                // Preencher os intervalos se existirem
                if (cardioExercise.cardio_details && cardioExercise.cardio_details.length > 0) {
                  console.log('Carregando detalhes de cardio:', cardioExercise.cardio_details)
                  state.cardio.intervalos = cardioExercise.cardio_details.map((detail) => {
                    console.log('Detalhe original da API:', detail)
                    console.log('VO2 original da API:', detail.vo2_per_time)
                    const intervalo = {
                      estagio: detail.stage || '',
                      tempo: converterTempoParaInterface(detail.time, isMetodoIntervalado()),
                      distancia: detail.distance || '',
                      tempo_recuperacao: converterTempoParaInterface(
                        detail.recovery_time,
                        isMetodoIntervalado(),
                      ),
                      carga: detail.load || '',
                      fca: detail.fca || '',
                      pace: detail.pace || '',
                      vo2_t: detail.vo2_per_time || '',
                      fctr: detail.fctr || '',
                    }
                    console.log('Intervalo carregado:', intervalo)
                    console.log(
                      'Campo vo2_t carregado:',
                      detail.vo2_per_time,
                      '->',
                      intervalo.vo2_t,
                    )
                    return intervalo
                  })
                  console.log('Intervalos preenchidos:', state.cardio.intervalos)
                }
              } else {
                console.log('Exercício encontrado mas não tem dados de cardio específicos')
                // Limpar dados quando não há dados específicos
                limparDadosCardio()
              }
            } else {
              console.log(
                'Nenhum exercício de cardio encontrado para o grupo:',
                state.trainingPlanGroupId,
              )
              // Limpar ID do exercício existente quando não há exercícios
              state.existingCardioExerciseId = null
              // Limpar dados quando não há exercícios
              limparDadosCardio()
            }
          })
          .catch((error) => {
            console.error('Erro ao buscar dados de cardio:', error)
            // Limpar dados em caso de erro
            limparDadosCardio()
          })
      }
    }

    // Função para limpar dados de cardio
    function limparDadosCardio() {
      state.cardio = {
        cardio_method_id: 0,
        cardio_modality_id: 0,
        cardio_exercise_id: 0,
        vo2_max: '',
        fcm: '',
        vo2_percent: '',
        fcm_percent: '',
        intervalos: [
          {
            estagio: '',
            tempo: '',
            distancia: '',
            // Campos para método intervalado
            tempo_recuperacao: '',
            carga: '',
            fca: '',
            // Campos para método contínuo
            pace: '',
            vo2_t: '',
            fctr: '',
          },
        ],
        resumo: null, // Para armazenar os totais e médias
      }
      state.existingCardioExerciseId = null
      console.log('Dados de cardio limpos')
    }

    function elaborarTreino() {
      router.push(`/elaborar-treino`)
    }

    // Função para atualizar exercícios de cardio
    function atualizarExerciciosCardio(exerciseId, data) {
      store.commit('SET_SPLASH_SCREEN', true)
      planosTreinoRepository
        .PlanoTreinoAtualizarExerciciosCardioPorId(exerciseId, data)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: 'Atualizado!',
              text: 'Exercícios de cardio atualizados com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error('Erro ao atualizar exercícios de cardio:', error)
          swal({
            icon: 'error',
            title: 'Erro ao atualizar exercícios de cardio!',
            text: error.message,
          })
        })
    }

    watch(
      () => state.trainingPlanGroupId,
      (newVal) => {
        state.testedExerciseSelected = '' // Reset selected exercise
      },
    )

    // Função para verificar se um dia tem exercícios de cardio
    function hasCardioExercises(day) {
      return day.exercises && day.exercises.some((exercise) => exercise.is_cardio)
    }

    // Função para converter tempo de MM:SS para HH:MM:SS
    const converterTempoParaAPI = (tempo) => {
      if (!tempo) return '00:00:00'

      // Se já está no formato HH:MM:SS, retorna como está
      if (tempo.includes(':') && tempo.split(':').length === 3) {
        return tempo
      }

      // Se está no formato MM:SS, converte para HH:MM:SS
      if (tempo.includes(':') && tempo.split(':').length === 2) {
        const [minutos, segundos] = tempo.split(':')
        return `00:${minutos.padStart(2, '0')}:${segundos.padStart(2, '0')}`
      }

      return '00:00:00'
    }

    // Função para converter tempo de HH:MM:SS para MM:SS (para método intervalado)
    const converterTempoParaInterface = (tempo, isIntervalado = false) => {
      if (!tempo) return isIntervalado ? '00:00' : '00:00:00'

      // Se é método intervalado e o tempo está no formato HH:MM:SS, converte para MM:SS
      if (isIntervalado && tempo.includes(':') && tempo.split(':').length === 3) {
        const [horas, minutos, segundos] = tempo.split(':')
        // Se as horas são 00, retorna apenas MM:SS
        if (horas === '00') {
          return `${minutos}:${segundos}`
        }
        // Se há horas, calcula o total de minutos
        const totalMinutos = parseInt(horas) * 60 + parseInt(minutos)
        return `${totalMinutos}:${segundos}`
      }

      return tempo
    }

    // Função para converter tempo em segundos (para cálculos)
    const converterTempoParaSegundos = (tempo) => {
      if (!tempo) return 0

      if (tempo.includes(':')) {
        const partes = tempo.split(':')
        if (partes.length === 2) {
          // Formato MM:SS
          const minutos = parseInt(partes[0]) || 0
          const segundos = parseInt(partes[1]) || 0
          return minutos * 60 + segundos
        } else if (partes.length === 3) {
          // Formato HH:MM:SS
          const horas = parseInt(partes[0]) || 0
          const minutos = parseInt(partes[1]) || 0
          const segundos = parseInt(partes[2]) || 0
          return horas * 3600 + minutos * 60 + segundos
        }
      }

      return parseInt(tempo) || 0
    }

    // Função para formatar segundos de volta para formato de tempo
    const formatarSegundosParaTempo = (segundos, isIntervalado = false) => {
      if (!segundos || segundos === 0) return isIntervalado ? '00:00' : '00:00:00'

      const horas = Math.floor(segundos / 3600)
      const minutos = Math.floor((segundos % 3600) / 60)
      const segs = segundos % 60

      if (isIntervalado && horas === 0) {
        // Para método intervalado, retorna MM:SS se não há horas
        return `${minutos.toString().padStart(2, '0')}:${segs.toString().padStart(2, '0')}`
      } else {
        // Para método contínuo ou quando há horas, retorna HH:MM:SS
        return `${horas.toString().padStart(2, '0')}:${minutos
          .toString()
          .padStart(2, '0')}:${segs.toString().padStart(2, '0')}`
      }
    }

    // Função para validar e garantir que o cardio_exercise_id seja válido
    const validarCardioExerciseId = () => {
      const exerciseId = state.cardio.cardio_exercise_id

      // Se não há ID selecionado
      if (!exerciseId || exerciseId === 0 || exerciseId === '0') {
        return false
      }

      // Verificar se o exercício existe na lista
      const exercicioExiste = state.exercicios.some((ex) => ex.id === parseInt(exerciseId))

      if (!exercicioExiste) {
        console.warn('Exercício de cardio não encontrado na lista:', exerciseId)
        return false
      }

      return true
    }

    // ✅ NOVA FUNÇÃO: apaga exercícios selecionados
    async function apagarSelecionados() {
      const groupId = parseInt(state.trainingPlanGroupId)
      if (!groupId || isNaN(groupId)) {
        swal({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Selecione um grupo antes de apagar.',
        })
        return
      }

      // Filtrar exercícios selecionados
      const exerciciosSelecionados = state.treinoElaborado.filter(item => item.checkCopy === true)

      if (exerciciosSelecionados.length === 0) {
        swal({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Nenhum exercício selecionado.',
        })
        return
      }

      swal({
        title: 'Tem certeza?',
        text: `Deseja apagar ${exerciciosSelecionados.length} exercício(s) selecionado(s)?`,
        showCancelButton: true,
        confirmButtonText: 'Sim, apagar',
        cancelButtonText: 'Não, cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-danger',
          cancelButton: 'btn bg-gradient-secondary',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (!result.isConfirmed) return

        try {
          store.commit('SET_SPLASH_SCREEN', true)

          // Apagar cada exercício selecionado
          for (const exercicio of exerciciosSelecionados) {
            if (exercicio.id) {
              // Exercício já salvo no banco - deletar via API
              if (state.trainingType === 'peso') {
                await planosTreinoRepository.PlanoTreinoExercicioGrupoIndividualDelete(exercicio.id)
              } else {
                await planosTreinoRepository.PlanoTreinoExercicioCardioGrupoIndividualDelete(exercicio.id)
              }
            }
          }

          // Remover do array local
          state.treinoElaborado = state.treinoElaborado.filter(item => !item.checkCopy)

          store.commit('SET_SPLASH_SCREEN', false)

          swal({
            title: 'Removido!',
            text: `${exerciciosSelecionados.length} exercício(s) apagado(s) com sucesso!`,
            icon: 'success',
            customClass: {
              confirmButton: 'btn bg-gradient-success',
            },
            buttonsStyling: false,
          })

          // Recarregar a semana atual (se houver)
          if (state.selectedWeek) {
            await buscarTreinoSemana()
          }
        } catch (error) {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error('Erro ao apagar exercícios selecionados:', error)
          swal({
            icon: 'error',
            title: 'Erro!',
            text: error.message || 'Erro ao apagar exercícios selecionados.',
          })
        } finally {
          store.commit('SET_SPLASH_SCREEN', false)
        }
      })
    }

    // ✅ COMPUTED: verifica se tem exercícios selecionados
    const temExerciciosSelecionados = computed(() => {
      return state.treinoElaborado.some(item => item.checkCopy === true)
    })

    // ✅ COMPUTED: verifica se tem exercícios copiados no clipboard
    const temExerciciosCopiados = computed(() => {
      return store.getters.getCopyExercises.length > 0
    })

    // NOVA FUNÇÃO: apaga todos os treinos do grupo selecionado (peso ou cardio)
    async function apagarTodosDoGrupo() {
      const groupId = parseInt(state.trainingPlanGroupId)
      if (!groupId || isNaN(groupId)) {
        swal({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Selecione um grupo antes de apagar.',
        })
        return
      }

      swal({
        title: 'Tem certeza?',
        text: `Deseja apagar todos os treinos do grupo selecionado?`,
        showCancelButton: true,
        confirmButtonText: 'Sim, apagar',
        cancelButtonText: 'Não, cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-danger',
          cancelButton: 'btn bg-gradient-secondary',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (!result.isConfirmed) return

        try {
          store.commit('SET_SPLASH_SCREEN', true)
          let response
          if (state.trainingType === 'peso') {
            response = await planosTreinoRepository.PlanoTreinoExercicioByGrupoIdDelete(
              groupId,
            )
          } else {
            response =
              await planosTreinoRepository.PlanoTreinoExercicioCardioByGrupoIdDelete(
                groupId,
              )
          }
          store.commit('SET_SPLASH_SCREEN', false)

          if (response && response.data && response.data.success) {
            // Mensagem de sucesso
            swal({
              title: 'Removido!',
              text: 'Treinos do grupo apagados com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            })

            // Limpar estados locais relevantes
            if (state.trainingType === 'peso') {
              state.treinoElaborado = []
            } else {
              limparDadosCardio()
            }
            state.existingCardioExerciseId = null

            // Recarregar a semana atual (se houver)
            if (state.selectedWeek) {
              await buscarTreinoSemana()
            }
          } else {
            swal({
              icon: 'error',
              title: 'Erro!',
              text: (response && response.data && response.data.message) || 'Erro ao apagar treinos.',
            })
          }
        } catch (error) {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error('Erro ao apagar treinos do grupo:', error)
          swal({
            icon: 'error',
            title: 'Erro!',
            text: error.message || 'Erro ao apagar treinos do grupo.',
          })
        } finally {
          store.commit('SET_SPLASH_SCREEN', false)
        }
      })
    }

    // Função para formatar números grandes (100k, 1.5Mi, etc)
    function formatarNumeroGrande(valor) {
      if (valor === null || valor === undefined || valor === 0) return '0'

      const num = parseFloat(valor)

      if (num >= 1000000) {
        // Milhões
        const milhoes = num / 1000000
        return milhoes % 1 === 0 ? `${milhoes}Mi` : `${milhoes.toFixed(1)}Mi`
      } else if (num >= 1000) {
        // Milhares
        const milhares = num / 1000
        return milhares % 1 === 0 ? `${milhares}k` : `${milhares.toFixed(1)}k`
      }

      return num.toString()
    }

    return {
      state,
      removerDiaSemana,
      buscarGrupoPorModalidade,
      buscarExercicioPorGrupo,
      buscarGrupoPorModalidadeCardio,
      buscarExercicioPorGrupoCardio,
      buscarMetodos,
      adicionarIntervalo,
      removerUltimoIntervalo,
      calcularTotais,
      adicionarExercicio,
      adicionarExercicioNaAba, // ✅ NOVA FUNÇÃO
      atualizarExerciciosGrupo, // ✅ NOVA FUNÇÃO - Listener para update do filho (grupo/elaborador)
      atualizarExerciciosDia, // ✅ NOVA FUNÇÃO - Listener para update do filho (dia)
      exercicioJaAdicionado, // ✅ NOVA FUNÇÃO - Mostrar ícone ✓ no select
      adicionarExerciciosGrupo,
      limparExercicios,
      buscarTreinoSemana,
      adicionarGruposDias,
      totalizadoresEstrategicos,
      buscaExercicioGrupoTreino,
      elaborarTreino,
      mudarTipoTreino,
      getTituloTreinamentoCardio,
      isMetodoIntervalado,
      isMetodoContinuo,
      getColunaTempo,
      getPlaceholderTempo,
      getMascaraTempo,
      getTextoBotao,
      atualizarExerciciosCardio,
      hasCardioExercises,
      carregarTodosExercicios,
      limparDadosCardio,
      converterTempoParaAPI,
      converterTempoParaInterface,
      converterTempoParaSegundos,
      formatarSegundosParaTempo,
      validarCardioExerciseId,
      apagarTodosDoGrupo,
      apagarSelecionados, // ✅ NOVA FUNÇÃO
      temExerciciosSelecionados, // ✅ NOVO COMPUTED
      temExerciciosCopiados, // ✅ COMPUTED: verifica exercícios copiados no clipboard
      formatarNumeroGrande, // Formatar números grandes (100k, 1.5Mi)
      buscarTotalizadoresCardio, // ✅ Buscar totais de cardio do backend
    }
  },
}
</script>

<style scoped>
.totals-table {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 0.95rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid #dee2e6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 0;
}

.totals-table thead th {
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.65rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.totals-table tbody td {
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  vertical-align: middle;
  white-space: nowrap;
}

.totals-table tbody td.fw-semibold {
  font-weight: 600;
}

/* Estilo específico para tabela de cardio */
.totals-table-cardio thead th {
  background-color: #fff5f5;
}

.totals-table-cardio tbody td {
  font-weight: 500;
}

/* Estilo para exercícios já adicionados no select */
.select-exercicios-testados .exercise-added {
  background-color: #e3f2fd !important;
  font-weight: 500;
}

.select-exercicios-testados .icon-added {
  color: #1976d2;
  font-weight: bold;
  font-size: 1.1em;
  margin-right: 4px;
}

.select-exercicios-testados option.exercise-added:hover {
  background-color: #bbdefb !important;
}
</style>